/*!
 * LANA3D v0.3.0
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As LANA3D depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/**
 * 
 * @namespace
 */
var LANA3D = LANA3D || {};

LANA3D.Three = LANA3D.Three || {};

LANA3D.Three.augment = function ( receivingClass, givingClass ) {
    for ( var methodName in givingClass.prototype ) {
        if ( !Object.hasOwnProperty(receivingClass.prototype, methodName) ) {
            receivingClass.prototype[methodName] = givingClass.prototype[methodName];
        }
    }
};
        
LANA3D.Three.Adapter = (function () {
    function Adapter(internal, args) {
        if (internal === undefined && this.internalType !== undefined) {
            if(!Function.prototype.bind) {
                var object = Object.create(this.internalType.prototype);
                var result = this.internalType.apply(object, this.internalConstructorArgs.concat(args));
                if (typeof result === 'object') {
                    this._internal = result;
                } else {
                    this._internal = object;
                }
            } else {
                var args = [null].concat(this.internalConstructorArgs).concat(args);
                var factory = this.internalType.bind.apply(this.internalType, args);
                this._internal = new factory();

            }
        } else {
            this._internal = internal;
        }
    }
    
    Adapter.prototype.internalConstructorArgs = [];

    Adapter.prototype.getInternal = function () {
        return this._internal;
    };

    Adapter.prototype.setInternal = function (internal) {
        this._internal = internal;
    };

    return Adapter;
})();

/**
 * Manager class used to create, destroy and retrieve nodes.
 * @constructor
 */
LANA3D.NodeManager = function () {
};

/**
 * Gets its instance
 * @static
 * @returns {LANA3D.NodeManager}
 */
LANA3D.NodeManager.getInstance = function() {
    
};

LANA3D.NodeManager.prototype = {
    createNode: function (type) {},
    
    destroyNode: function (node) {},
    
    findNodeById: function (id) {},
    
    findNodeByType: function (type) {}
};

/**
 * Creates a new node
 * @static
 * @param {string} node type identifier
 * @returns {LANA3D.Node}
 */
LANA3D.NodeManager.createNode = function (type) {
    return LANA3D.NodeManager.getInstance().createNode.apply(this, arguments);
};

/**
 * Destroys a node
 * @static
 * @param {LANA3D.Node} node
 */
LANA3D.NodeManager.destroyNode = function (node) {
   LANA3D.NodeManager.getInstance().destroyNode(node);
};

/**
 * Finds node by id
 * @static
 * @param {int} id
 * @returns {LANA3D.Node}
 */
LANA3D.NodeManager.findNodeById = function (id) {
    return LANA3D.NodeManager.getInstance().findNodeById(id);
};

/**
 * Finds nodes by type
 * @param {string} node type identifier
 * @returns {Array.<LANA3D.Node>}
 */
LANA3D.NodeManager.findNodeByType = function (type) {
    return LANA3D.NodeManager.getInstance().findNodeByType(type);
};


(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.NodeManager;
        var _instance;
        var _nodes = {};
        var _constructors = [];
        var _defaultConstructor;

        function NodeManagerImpl() {
            _interface.apply ( this, arguments );
        }
        NodeManagerImpl.prototype = Object.create( LANA3D.NodeManager.prototype);

        function getInstance() {
            if (_instance === undefined) {
                _instance = new NodeManagerImpl();
            }
            return _instance;
        }

        NodeManagerImpl.prototype.createNode = function (type) {
            var newNode;
            var args = new Array(arguments.length - 1);
            for(var j = 0; j < args.length; ++j) {
                args[j] = arguments[j + 1];
            }
            for (var i=0; i<_constructors.length; i++){
                if (type.localeCompare(_constructors[i].prototype.type) === 0) {
                    newNode = new _constructors[i](undefined, args);
                    _nodes[newNode.getId()] = newNode;
                    break;
                }
            }

            if (newNode === undefined && _defaultConstructor !== undefined) {
                newNode = new _defaultConstructor(undefined, args);
            }

            return newNode;
        };

        NodeManagerImpl.prototype.destroyNode = function (node) {
            if (node instanceof LANA3D.Node) {
                var id = node.getId();
                node.setParent(null);
                if (_nodes.hasOwnProperty(id)) {
                    delete _nodes[id];
                }
            }

        };

        NodeManagerImpl.prototype.findNodeById = function (id) {
            if (_nodes.hasOwnProperty(id)) {
                return _nodes[id];
            } else {
                return undefined;
            }
        };

        NodeManagerImpl.prototype.getNodeFromInternal = function (internal) {
            if( !(internal instanceof THREE.Object3D) )
                return undefined;

            var node = _nodes[internal.id];
            if (node === undefined) {
                var validConstructors = [];
                for (var i=_constructors.length -1; i> -1; i--) {
                    if (!_constructors[i].prototype.disableGetFromInternal && internal instanceof _constructors[i].prototype.internalType) {
                        validConstructors.push(_constructors[i]);
                    }
                }
                if (validConstructors.length === 1) {
                    node = new validConstructors[0] (internal);
                } else if (validConstructors.length > 1) {
                    var childConstructor = validConstructors[0];
                    for (i=1; i<validConstructors.length;i++) {
                        if (validConstructors[i].prototype instanceof childConstructor) {
                            childConstructor = validConstructors[i];
                        }
                    }
                    node = new childConstructor (internal);
                }
                if (node !== undefined) {
                    _nodes[node.getId()] = node;
                }
            }
            return node;
        };

        NodeManagerImpl.prototype.registerConstructor = function (constructor) {
            _constructors.push(constructor);
            if(constructor.prototype.type === undefined) {
                _defaultConstructor = constructor;
            }
        };

        LANA3D.NodeManager.getInstance = getInstance;
    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Manager class to create, destroy and retrieve assetss.
 * @constructor
 */
LANA3D.AssetManager = function () {};

/**
 * Gets its instance
 * @returns {LANA3D.AssetManager}
 */
LANA3D.AssetManager.getInstance = function () {};

LANA3D.AssetManager.prototype = {
    loadBundle: function (path, callback) {},

    parseBundle: function (type, content) {},

    exportBundle: function(type, scene, animations) {},

    createLoader: function (type) {},

    createAsset: function (type) {},

    destroyAsset: function (asset) {},

    findAssetById: function (id) {},

    findAssetByType: function (type) {}

};

/**
 * Loads an asset bundle
 * @static
 * @returns {Object} result - result object
 * @returns {Array.<LANA3D.Asset>} result.assets - loaded assets
 * @returns {LANA3D.Scene} result.scene - loaded scene
 * @param {string} path
 * @param {type} callback
 */
LANA3D.AssetManager.loadBundle = function (path, callback) {
    LANA3D.AssetManager.getInstance().loadBundle(path, callback);
};

LANA3D.AssetManager.parseBundle = function (type, content) {
    return LANA3D.AssetManager.getInstance().parseBundle.apply(this, arguments);
};

LANA3D.AssetManager.exportBundle = function (type, scene, animations) {
    return LANA3D.AssetManager.getInstance().exportBundle.apply(this, arguments);
};

/**
 * Creates a new asset
 * @static
 * @param {string} type
 * @returns {LANA3D.Asset}
 */
LANA3D.AssetManager.createAsset = function (type) {
    return LANA3D.AssetManager.getInstance().createAsset.apply(this, arguments);
};

/**
 * Destroys an asset
 * @static
 * @para {LANA3D.Asset} asset
 */
LANA3D.AssetManager.destroyAsset = function (asset) {
    return LANA3D.AssetManager.getInstance().destroyAsset(asset);
};

/**
 * Finds asset by id
 * @static
 * @param {int} id
 * @returns {LANA3D.Asset}
 */
LANA3D.AssetManager.findAssetById = function (type) {
    return LANA3D.AssetManager.getInstance().findAssetById(type);
};

/**
 * Finds asssets by type
 * @static
 * @param {string} type
 * @returns {Array.<LANA3D.Asset>} assets
 */
LANA3D.AssetManager.findAssetByType = function (type) {
    return LANA3D.AssetManager.getInstance().findAssetByType(type);
};
(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.AssetManager;
        var _instance;
        var _assetsById = {};
        var _assetsByConstructors = [];
        var _constructors = [];
        var _bundleLoaders = [];
        var _bundleLoadersInstances = [];
        var _bundleExporters = [];
        var _bundleExportersInstances = [];
        var _nextId = 0;

        function AssetManagerImpl() {
            _interface.apply ( this, arguments );
        }
        AssetManagerImpl.prototype = Object.create( LANA3D.AssetManager.prototype);

        function getInstance() {
            if (_instance === undefined) {
                _instance = new AssetManagerImpl();
            }
            return _instance;
        }

        LANA3D.AssetManager.getInstance = getInstance;
        AssetManagerImpl.getInstance = getInstance;


        AssetManagerImpl.prototype.findAssetById = function (id) {
            if (_assetsById[id]){
                return _assetsById[id];
            }
            return undefined;
        };

        AssetManagerImpl.prototype.findAssetByType = function (type) {
            var retAssets = [];
            for (var assetId in _assetsById) {
                if (_assetsById[assetId].type === type){
                    retAssets.push(_assetsById[assetId]);
                }
            }
            return retAssets;
        };

        function processScene(scene) {
            var result = {_internal: scene, assets: []};
            result.scene = LANA3D.NodeManager.getInstance().createNode("scene");
            //scene nodes
            var nodeNums = scene.children.length;
            for(var nodeNumsID = 0; nodeNumsID < nodeNums; nodeNumsID++){
                var n = LANA3D.NodeManager.getInstance().getNodeFromInternal(scene.children[0]);
                if(n !== undefined)
                    result.scene.addChild(n);
            }
            for (var i=0;i< scene.animations.length;i++) {
                var clip = _instance.createAsset("animationclip");
                clip.setInternal(scene.animations[i].data);
                clip.setId(scene.animations[i].name);
                clip.setName(scene.animations[i].name);
                clip._loadedRootNodeName = scene.animations[i].rootName;

                result.assets.push(clip);
            }
            if(scene.skeleton)
            {
                var skeleton = _instance.createAsset("skeleton");
                skeleton._internal = scene.skeleton;

                result.assets.push(skeleton);
            }
            return result;
        }

        AssetManagerImpl.prototype.loadBundle = function (path, callback) {
            var filename = path.split( '\\' ).pop().toLowerCase();
            var extension = filename.split( '.' ).pop().toLowerCase();
            var loader = getLoader(extension);
            if(loader){
                loader.load( path, function ( scene ) {
                    var result = processScene(scene);
                    callback(result);
                });
            }else{
                //error message 'Can't load extension models'
            }
        };

        AssetManagerImpl.prototype.parseBundle = function (type, content) {
            var result;
            var loader = getLoader(type);
            if(loader){
                var scene = loader.parse(content);
                result = processScene(scene);
            }
            return result;
        };

        AssetManagerImpl.prototype.exportBundle = function(type, scene, animations) {
            var ret;
            var exporter = getExporter(type);
            if (exporter) {
                ret = exporter.export(scene, animations);
            }
            return ret;

        };

        AssetManagerImpl.prototype.createAsset = function (type) {
            var newAsset;
            for (var i=0; i<_constructors.length; i++){
                if (type.localeCompare(_constructors[i].prototype.type) === 0) {
                    //Pass extra arguments
                    var args = new Array(arguments.length - 1);
                    for(var j = 0; j < args.length; ++j) {
                        args[j] = arguments[j + 1];
                    }
                    newAsset = new _constructors[i](undefined, args);
                    newAsset._id = _nextId++;
                    //TODO: assets ids
                    _assetsById[newAsset.getId()] = newAsset;
                    break;
                }
            }

            return newAsset;
        };

        AssetManagerImpl.prototype.getAssetFromInternal = function(internal, id) {
            var asset;

            for (var i=0; i<_constructors.length; i++) {
                if (_constructors[i].prototype.internalType !== undefined &&
                        internal instanceof _constructors[i].prototype.internalType) {
                    if(_assetsByConstructors[i].hasOwnProperty(internal.id)) {
                        asset = _assetsByConstructors[i][internal.id];
                        asset.setId(id);
                        _assetsById[id] = asset;
                    } else if (id !== undefined && _assetsById.hasOwnProperty(id)) {
                        asset = _assetsById[id];
                        asset.setInternal(internal);
                        _assetsByConstructors[i][internal.id] = asset;
                    } else {
                        if(id === undefined) {
                            id = _constructors[i].prototype.type + internal.id;
                        }
                        asset = new _constructors[i] (internal);
                        asset._id = id;
                        _assetsById[id] = asset;
                        _assetsByConstructors[i][internal.id] = asset;
                    }
                    break;
                }
            }
            return asset;
        };

        AssetManagerImpl.prototype.registerConstructor = function (constructor) {
            _constructors.push(constructor);
            _assetsByConstructors.push({});
        };

        function getLoader (type) {
            var loader;
            for (var i=0; i<_bundleLoaders.length; i++){
                for (var j=0; j<_bundleLoaders[i].prototype.type.length; j++){
                    if (type === _bundleLoaders[i].prototype.type[j])
                    {
                        loader = _bundleLoadersInstances[i];
                        if(loader === undefined) {
                            loader = new _bundleLoaders[i]();
                            _bundleLoadersInstances[i] = loader;
                        }
                        break;
                    }
                }
            }

            return loader;
        }

        function getExporter (type) {
            var exporter;
            for (var i=0; i<_bundleExporters.length; i++){
                for (var j=0; j<_bundleExporters[i].prototype.type.length; j++){
                    if (type === _bundleExporters[i].prototype.type[j])
                    {
                        exporter = _bundleExportersInstances[i];
                        if(exporter === undefined) {
                            exporter = new _bundleExporters[i]();
                            _bundleExportersInstances[i] = exporter;
                        }
                        break;
                    }
                }
            }

            return exporter;
        }

        AssetManagerImpl.prototype.registerBundleLoader = function (loader) {
            _bundleLoaders.push(loader);
            _bundleLoadersInstances.push(undefined);
        };

        AssetManagerImpl.prototype.registerBundleExporter = function (exporter) {
            _bundleExporters.push(exporter);
            _bundleExportersInstances.push(undefined);
        };

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * 
 * @returns {LANA3D.Asset} Base class for assets
 * @constructor
 */
LANA3D.Asset = function () {
};

LANA3D.Asset.prototype = {
    /**
     * Gets asset id
     * @returns {int}
     */
    getId: function () {},
    
     /**
     * Gets asset type
     * @returns {string}
     */
    getType: function () {}
};

(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.Asset; 
        function AssetImpl() {
            _interface.apply ( this, arguments );
            this._id = arguments[0];
            ThreeImpl.Adapter.apply ( this, arguments );

        }
        AssetImpl.prototype = Object.create( LANA3D.Asset.prototype);

        ThreeImpl.augment(AssetImpl, ThreeImpl.Adapter);

        AssetImpl.prototype.getId = function () {
            return this._id;
        };

        AssetImpl.prototype.setId = function (id) {
            this._id = id;
        };

        LANA3D.Asset = function () {
            AssetImpl.apply ( this, arguments );
        };

        LANA3D.Asset.prototype = AssetImpl.prototype;

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Color class
 * @constructor
 */
LANA3D.Color = function () {
};


(function (LANA3D) {

    var _internal = THREE.Color;

    function ColorImpl() {
        _internal.apply ( this, arguments );
    }
    ColorImpl.prototype = Object.create( THREE.Color.prototype);

    LANA3D.Color = function () {
        ColorImpl.apply ( this, arguments );
    };

    LANA3D.Color.prototype = ColorImpl.prototype;

    THREE.Color = LANA3D.Color;

}) (LANA3D || (LANA3D = {}));

/**
 * Class for material assets
 * @constructor
 * @augments LANA3D.Asset
 */
LANA3D.Material = function () {
    LANA3D.Asset.apply ( this, arguments );
};

/**
 * Material type identifier
 * @type string
 */
LANA3D.Material.prototype.type = "material";

LANA3D.Material.prototype.getProperty = function(name) {};
LANA3D.Material.prototype.setProperty = function(name, value) {};


(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.Material;
        function MaterialImpl() {
            _interface.apply ( this, arguments );
        }
        MaterialImpl.prototype = Object.create( LANA3D.Asset.prototype);

        ThreeImpl.augment(MaterialImpl, LANA3D.Material);

        MaterialImpl.prototype.internalType = THREE.MeshPhongMaterial;

        MaterialImpl.prototype.getProperty = function(name) {
            return this.getInternal()[name];
        };
        
        MaterialImpl.prototype.setProperty = function(name, value) {
            this.getInternal()[name] = value;
        };

        LANA3D.Material = function () {
            MaterialImpl.apply ( this, arguments );
        };

        LANA3D.Material.prototype = MaterialImpl.prototype;

        LANA3D.AssetManager.getInstance().registerConstructor(LANA3D.Material);

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Texture asset class
 * @constructor
 * @augments LANA3D.Asset
 */
LANA3D.Texture = function () {
    LANA3D.Asset.apply ( this, arguments );
};

/**
 * Texture asset type identifier
 * @type string
 */
LANA3D.Texture.prototype.type = "texture";
(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.Texture;
        function TextureImpl() {
            _interface.apply( this, arguments );
        }
        TextureImpl.prototype = Object.create( LANA3D.Asset.prototype);

        ThreeImpl.augment(TextureImpl, LANA3D.Texture);

        TextureImpl.prototype.internalType = THREE.Texture;

        LANA3D.Texture = function () {
            TextureImpl.apply(this, arguments);
        };

        LANA3D.Texture.prototype = TextureImpl.prototype;

        LANA3D.AssetManager.getInstance().registerConstructor(LANA3D.Texture);

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Skeleton asset class
 * @constructor
 * @augments LANA3D.Asset
 */
LANA3D.Skeleton = function () {
    LANA3D.Asset.apply ( this, arguments );
};

/**
 * Skeleton asset type identifier
 * @type string
 */
LANA3D.Skeleton.prototype.type = "skeleton";
(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.Skeleton;
        function SkeletonImpl() {
            _interface.apply( this, arguments );
        }
        SkeletonImpl.prototype = Object.create( LANA3D.Asset.prototype);

        ThreeImpl.augment(SkeletonImpl, LANA3D.Skeleton);

        SkeletonImpl.prototype.internalType = THREE.Skeleton;

        LANA3D.Skeleton = function () {
            SkeletonImpl.apply(this, arguments);
        };

        LANA3D.Skeleton.prototype = SkeletonImpl.prototype;

        LANA3D.AssetManager.getInstance().registerConstructor(LANA3D.Skeleton);

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Geometry asset class
 * @constructor
 * @augments LANA3D.Asset
 */
LANA3D.Geometry = function () {
    LANA3D.Asset.apply ( this, arguments );
};

/**
 * Geometry type identifier
 * @type string
 */
LANA3D.Geometry.prototype.type = "geometry";

/**
 * Gets geometry vertices
 * @returns {Array.<LANA3D.Vector3>} vertices
 */
LANA3D.Geometry.prototype.getVertices = function () {};

/**
 * Sets geometry vertices
 * @param {Array.<LANA3D.Vector3>} vertices
 */
LANA3D.Geometry.prototype.setVertices = function ( vertices ) {};

/**
 * Gets geometry normals
 * @returns {Array.<LANA3D.Vector3>}
 */
LANA3D.Geometry.prototype.getNormals = function () {};

/**
 * Sets geometry normals
 * @param {Array.<LANA3D.Vector3>} normals
 */
LANA3D.Geometry.prototype.setNormals = function ( normals ) {};

/**
 * Gets geometry faces
 * @returns {Array.<LANA3D.Vector3>}
 */
LANA3D.Geometry.prototype.getFaces = function () {};

/**
 * Sets geometry faces
 * @param {Array.<LANA3D.Vector3>} faces
 */
LANA3D.Geometry.prototype.setFaces = function ( faces ) {};
(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.Geometry;
        function GeometryImpl() {
            _interface.apply ( this, arguments );
        }
        GeometryImpl.prototype = Object.create( LANA3D.Asset.prototype);

        ThreeImpl.augment(GeometryImpl, LANA3D.Geometry);

        GeometryImpl.prototype.internalType = THREE.Geometry;

        GeometryImpl.prototype.getVertices = function () {
            return this.getInternal().vertices;
        };

        GeometryImpl.prototype.setVertices = function ( vertices ) {
            this.getInternal().vertices = vertices;
        };
        GeometryImpl.prototype.getNormals = function () {
            var normals = [];
            var _faces = this.getInternal().faces;
            for (var i=0; i<_faces.length; i++) {
                normals.push(_faces[i].normal);
            }
            return normals;

        };
        GeometryImpl.prototype.setNormals = function ( normals ) {
            var _faces = this.getInternal().faces;
            for (var i=0; i<normals.length; i++) {
                if (_faces.length<=i) {
                    _faces.push(new THREE.Face3(0, 0, 0, normals[i]));
                } else {
                    _faces[i].normal = normals[i];
                }
            }
        };
        GeometryImpl.prototype.getFaces = function () {
            var faces = [];
            var _faces = this.getInternal().faces;
            for (var i=0; i<_faces.length; i++) {
                faces.push(new LANA3D.Vector3(_faces[i].a, _faces[i].b, _faces[i].c));
            }
            return faces;
        };
        GeometryImpl.prototype.setFaces = function ( faces ) {
            var _faces = this.getInternal().faces;
            for (var i=0; i<faces.length; i++) {
                if (_faces.length<=i) {
                    _faces.push(new THREE.Face3(faces[i].x, faces[i].y, faces[i].z));
                } else {
                    _faces[i].a = faces[i].x;
                    _faces[i].b = faces[i].y;
                    _faces[i].c = faces[i].z;
                }
            }
        };

        LANA3D.Geometry = function () {
            GeometryImpl.apply ( this, arguments );
        };

        LANA3D.Geometry.prototype = GeometryImpl.prototype;

        LANA3D.AssetManager.getInstance().registerConstructor(LANA3D.Geometry);

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Sphere geometry class
 * @constructor
 * @augments LANA3D.Geometry
 */
LANA3D.SphereGeometry = function () {
    LANA3D.Geometry.apply ( this, arguments );
};

/**
 * Sphere geometry type identifier
 * @type string
 */
LANA3D.SphereGeometry.prototype.type = "geometry.sphere";
(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.SphereGeometry;
        function SphereGeometryImpl() {
            _interface.apply ( this, arguments );
        }
        SphereGeometryImpl.prototype = Object.create( LANA3D.Geometry.prototype);

        ThreeImpl.augment(SphereGeometryImpl, LANA3D.SphereGeometry);

        SphereGeometryImpl.prototype.internalType = THREE.SphereGeometry;

        LANA3D.SphereGeometry = function () {
            SphereGeometryImpl.apply ( this, arguments );
        };

        LANA3D.SphereGeometry.prototype = SphereGeometryImpl.prototype;

        LANA3D.AssetManager.getInstance().registerConstructor(LANA3D.SphereGeometry);

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Plane geometry class
 * @constructor
 * @augments LANA3D.Geometry
 */
LANA3D.PlaneGeometry = function () {
    LANA3D.Geometry.apply ( this, arguments );
};

/**
 * Sphere geometry type identifier
 * @type string
 */
LANA3D.PlaneGeometry.prototype.type = "geometry.plane";
(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.PlaneGeometry;
        function PlaneGeometryImpl() {
            _interface.apply ( this, arguments );
        }
        PlaneGeometryImpl.prototype = Object.create( LANA3D.Geometry.prototype);

        ThreeImpl.augment(PlaneGeometryImpl, LANA3D.PlaneGeometry);

        PlaneGeometryImpl.prototype.internalType = THREE.PlaneGeometry;

        LANA3D.PlaneGeometry = function () {
            PlaneGeometryImpl.apply ( this, arguments );
        };

        LANA3D.PlaneGeometry.prototype = PlaneGeometryImpl.prototype;

        LANA3D.AssetManager.getInstance().registerConstructor(LANA3D.PlaneGeometry);

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Box geometry class
 * @constructor
 * @augments LANA3D.Geometry
 */
LANA3D.BoxGeometry = function () {
    LANA3D.Geometry.apply ( this, arguments );
};

/**
 * Box geometry type identifier
 * @type string
 */
LANA3D.BoxGeometry.prototype.type = "geometry.box";
(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.BoxGeometry;
        function BoxGeometryImpl() {
            _interface.apply ( this, arguments );
        }
        BoxGeometryImpl.prototype = Object.create( LANA3D.Geometry.prototype);

        ThreeImpl.augment(BoxGeometryImpl, LANA3D.BoxGeometry);

        BoxGeometryImpl.prototype.internalType = THREE.BoxGeometry;

        LANA3D.BoxGeometry = function () {
            BoxGeometryImpl.apply ( this, arguments );
        };

        LANA3D.BoxGeometry.prototype = BoxGeometryImpl.prototype;

        LANA3D.AssetManager.getInstance().registerConstructor(LANA3D.BoxGeometry);

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Cylinder geometry class
 * @constructor
 * @augments LANA3D.Geometry
 */
LANA3D.CylinderGeometry = function () {
    LANA3D.Geometry.apply ( this, arguments );
};

/**
 * Cylinder geometry type identifier
 * @type string
 */
LANA3D.CylinderGeometry.prototype.type = "geometry.cylinder";
(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.CylinderGeometry;
        function CylinderGeometryImpl() {
            _interface.apply ( this, arguments );
        }
        CylinderGeometryImpl.prototype = Object.create( LANA3D.Geometry.prototype);

        ThreeImpl.augment(CylinderGeometryImpl, LANA3D.CylinderGeometry);

        CylinderGeometryImpl.prototype.internalType = THREE.CylinderGeometry;

        LANA3D.CylinderGeometry = function () {
            CylinderGeometryImpl.apply ( this, arguments );
        };

        LANA3D.CylinderGeometry.prototype = CylinderGeometryImpl.prototype;

        LANA3D.AssetManager.getInstance().registerConstructor(LANA3D.CylinderGeometry);

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Vector3 class
 * @param {float} x
 * @param {float} y
 * @param {float} z
 * @constructor
 */
LANA3D.Vector3 = function (x, y, z) {
};

LANA3D.Vector3.prototype = {
    set: function ( x, y, z ) {},
    
    getX: function ( ) {},
    
    getY: function ( ) {},
    
    getZ: function ( ) {},
    
    setX: function ( x ) {},
    
    setY: function ( y ) {},
    
    setZ: function ( z ) {}
};

(function (LANA3D) {

    var _internal = THREE.Vector3;

    function Vector3Impl(x, y, z) {
        _internal.call( this, x, y, z );
    }
    Vector3Impl.prototype = Object.create( THREE.Vector3.prototype);

    Vector3Impl.prototype.getX = function ( ) {
        return this.x;
    };

    Vector3Impl.prototype.getY = function ( ) {
        return this.y;
    };

    Vector3Impl.prototype.getZ = function ( ) {
        return this.z;
    };

    LANA3D.Vector3 = function (x, y, z) {
        Vector3Impl.call(this, x, y, z);
    };

    LANA3D.Vector3.prototype = Vector3Impl.prototype;

    THREE.Vector3 = LANA3D.Vector3;

}) (LANA3D || (LANA3D = {}));

/**
 * Vector2 class
 * @param {float} x
 * @param {float} y
 * @constructor
 */
LANA3D.Vector2 = function (x, y) {
};

LANA3D.Vector2.prototype = {
    set: function ( x, y ) {},
    
    getX: function ( ) {},
    
    getY: function ( ) {},
    
    setX: function ( x ) {},
    
    setY: function ( y ) {}
};

(function (LANA3D) {

    var _internal = THREE.Vector2;

    function Vector2Impl(x, y, z) {
        _internal.call( this, x, y, z );
    }
    Vector2Impl.prototype = Object.create( THREE.Vector2.prototype);

    Vector2Impl.prototype.getX = function ( ) {
        return this.x;
    };

    Vector2Impl.prototype.getY = function ( ) {
        return this.y;
    };

    LANA3D.Vector2 = function (x, y) {
        Vector2Impl.call(this, x, y);
    };

    LANA3D.Vector2.prototype = Vector2Impl.prototype;

    THREE.Vector2 = LANA3D.Vector2;

}) (LANA3D || (LANA3D = {}));

/**
 * Quaternion class
 * @param {float} x
 * @param {float} y
 * @param {float} z
 * @param {float} w
 * @constructor
 */
LANA3D.Quaternion = function (x, y, z, w) {
};

LANA3D.Quaternion.prototype = {
    set: function ( x, y, z, w ) {},
    
    getX: function ( ) {},
    
    getY: function ( ) {},
    
    getZ: function ( ) {},
    
    getW: function ( ) {},
    
    setX: function ( x ) {},
    
    setY: function ( y ) {},
    
    setZ: function ( z ) {},
    
    setW: function ( w ) {}
};

LANA3D.Quaternion.slerp = function (q0, q1, qrot, tNorm) {
};
(function (LANA3D) {

    var _internal = THREE.Quaternion;

    function QuaternionImpl( x, y, z, w) {
        _internal.call( this, x, y, z, w );
    }
    QuaternionImpl.prototype = Object.create( THREE.Quaternion.prototype);

    QuaternionImpl.prototype.getX = function ( ) {
        return this.x;
    };

    QuaternionImpl.prototype.getY = function ( ) {
        return this.y;
    };

    QuaternionImpl.prototype.getZ = function ( ) {
        return this.z;
    };
    
    QuaternionImpl.prototype.getW = function ( ) {
        return this.w;
    };
   
    LANA3D.Quaternion = function (x, y, z, w) {
        QuaternionImpl.call(this, x, y, z, w);
    };

    LANA3D.Quaternion.prototype = QuaternionImpl.prototype;
    
    var _slerp = THREE.Quaternion.slerp;

    LANA3D.Quaternion.slerp = function (q0, q1, qrot, tNorm) {
        _slerp(q0, q1, qrot, tNorm);
    };

    THREE.Quaternion = LANA3D.Quaternion;

}) (LANA3D || (LANA3D = {}));

/**
 * Matrix4x4 class
 * @constructor
 */
LANA3D.Matrix4x4 = function () {
};

LANA3D.Matrix4x4.prototype = {
    /**
     * Add matrix
     * @param {Matrix4x4}
     */
    add: function ( m ) {},
    /**
     * Sub matrix
     * @param {Matrix4x4}
     */
    sub: function ( m ) {},
	/**
     * Gets matix position
     * @returns {Vector3}
     */
    getPosition: function () {},

    /**
     * Gets matix quaternion
     * @returns {Quaternion}
     */
    getQuaternion: function () {}
};
(function (LANA3D) {

    var _internal = THREE.Matrix4;

    function Matrix4x4Impl() {
        _internal.apply( this, arguments );
    }
    Matrix4x4Impl.prototype = Object.create( THREE.Matrix4.prototype);

    Matrix4x4Impl.prototype.add = function ( m ) {
        this.elements[0] += m.elements[0];
        this.elements[1] += m.elements[1]; 
        this.elements[2] += m.elements[2]; 
        this.elements[3] += m.elements[3];  

        this.elements[4] += m.elements[4];
        this.elements[5] += m.elements[5]; 
        this.elements[6] += m.elements[6]; 
        this.elements[7] += m.elements[7]; 

        this.elements[8] += m.elements[8];
        this.elements[9] += m.elements[9]; 
        this.elements[10] += m.elements[10]; 
        this.elements[11] += m.elements[11]; 

        this.elements[12] += m.elements[12];
        this.elements[13] += m.elements[13]; 
        this.elements[14] += m.elements[14]; 
        this.elements[15] += m.elements[15]; 
    };

    Matrix4x4Impl.prototype.sub = function ( m ) {
        this.elements[0] -= m.elements[0];
        this.elements[1] -= m.elements[1]; 
        this.elements[2] -= m.elements[2]; 
        this.elements[3] -= m.elements[3];  

        this.elements[4] -= m.elements[4];
        this.elements[5] -= m.elements[5]; 
        this.elements[6] -= m.elements[6]; 
        this.elements[7] -= m.elements[7]; 

        this.elements[8] -= m.elements[8];
        this.elements[9] -= m.elements[9]; 
        this.elements[10] -= m.elements[10]; 
        this.elements[11] -= m.elements[11]; 

        this.elements[12] -= m.elements[12];
        this.elements[13] -= m.elements[13]; 
        this.elements[14] -= m.elements[14]; 
        this.elements[15] -= m.elements[15]; 
    };

    Matrix4x4Impl.prototype.getPosition = function ( ) {
        var positionVec = new LANA3D.Vector3();
        positionVec.setFromMatrixPosition( this );
        return positionVec;
    };

    Matrix4x4Impl.prototype.getQuaternion = function ( ) {
        var quaternion = new LANA3D.Quaternion();
        quaternion.setFromRotationMatrix( this );
        return quaternion;
    };

    LANA3D.Matrix4x4 = function () {
        Matrix4x4Impl.apply(this, arguments);
    };

    LANA3D.Matrix4x4.prototype = Matrix4x4Impl.prototype;

    THREE.Matrix4 = LANA3D.Matrix4x4;

}) (LANA3D || (LANA3D = {}));

LANA3D.Transform = function () {
    Object.defineProperty(this, 'position', {
        get: this.getPosition,
        set: this.setPosition
    });
    Object.defineProperty(this, 'rotation', {
        get: this.getRotation,
        set: this.setRotation
    });
    Object.defineProperty(this, 'scale', {
        get: this.getScale,
        set: this.setScale
    });
};

LANA3D.Transform.prototype = {

    getPosition: function () {
    },

    setPosition: function (position) {
    },

    getRotation: function () {
    },

    setRotation: function (rotation) {
    },

    getScale: function () {
    },

    setScale: function (scale) {
    },
};




(function (LANA3D) {
    var _interface = LANA3D.Transform;
    function TransformImpl() {
        _interface.apply ( this, arguments );
        this._node = arguments[0];
    }
    TransformImpl.prototype = Object.create( LANA3D.Transform.prototype);

    TransformImpl.prototype.getPosition = function ( ) {
        return this._node.getInternal().position;
    };

    TransformImpl.prototype.getRotation = function ( ) {
        return this._node.getInternal().rotation;
    };

    TransformImpl.prototype.getQuaternion = function ( ) {
        return this._node.getInternal().quaternion;
    };

    TransformImpl.prototype.getScale = function ( ) {
        return this._node.getInternal().scale;
    };

    TransformImpl.prototype.getMatrix = function ( ) {
        return this._node.getInternal().matrix;
    };

    TransformImpl.prototype.setPosition = function ( pos ) {
        this._node.getInternal().position.set(pos.x,pos.y,pos.z);
        this._node.getInternal().updateMatrix();
    };

    TransformImpl.prototype.translate = function ( tras ) {
        var trasMatrix = new LANA3D.Matrix4x4();
        trasMatrix.makeTranslation(tras.x, tras.y, tras.z);
        this._node.getInternal().matrix.multiply(trasMatrix);
        this._node.getInternal().position.setFromMatrixPosition(this._node.getInternal().matrix);
        this._node.getInternal().updateMatrix();
    }

    TransformImpl.prototype.setRotation = function ( rot ) {
        this._node.getInternal().rotation.set(rot.x, rot.y, rot.z);
        this._node.getInternal().updateMatrix();
    };

    TransformImpl.prototype.rotate = function ( axis, radians ) {
        var rotMatrix = new LANA3D.Matrix4x4();
        rotMatrix.makeRotationAxis(axis.normalize(), radians);
        this._node.getInternal().matrix.multiply(rotMatrix);
        this._node.getInternal().rotation.setFromRotationMatrix(this._node.getInternal().matrix);
        this._node.getInternal().updateMatrix();
    }

    TransformImpl.prototype.setQuaternion = function ( rot ) {
        this._node.getInternal().quaternion.set(rot.x, rot.y, rot.z, rot.w);
        this._node.getInternal().updateMatrix();
    };

    TransformImpl.prototype.setScale = function ( scl ) {
        this._node.getInternal().scale.set(scl.x,scl.y,scl.z);
        this._node.getInternal().updateMatrix();
    };

    LANA3D.Transform = function () {
        TransformImpl.apply(this, arguments);
    };

    LANA3D.Transform.prototype = TransformImpl.prototype;

}) (LANA3D || (LANA3D = {}));

/**
 * BoundingBox class
 * @constructor
 */
LANA3D.BoundingBox = function () {
};

LANA3D.BoundingBox.prototype = {
	getMinPoint: function() {},
	setMinPoint: function(point) {},
	getMaxPoint: function() {},
	setMaxPoint: function(point) {},
	getCenterPoint: function() {},
	computeFromVertices: function(vertices) {},
	compose: function(box) {}
};

(function (LANA3D) {

    var _internal = THREE.Box3;

    function BoundingBoxImpl() {
        _internal.call( this );
    }
    BoundingBoxImpl.prototype = Object.create( THREE.Box3.prototype);

    BoundingBoxImpl.prototype.getMinPoint = function() {
        return this.min;
    };

    BoundingBoxImpl.prototype.setMinPoint = function(point) {
        this.min = point;
    };

    BoundingBoxImpl.prototype.getMaxPoint = function() {
        return this.max;
    };

    BoundingBoxImpl.prototype.setMaxPoint = function(point) {
        this.max = point;
    };

    BoundingBoxImpl.prototype.getCenterPoint = function() {
        return this.center();
    };

    BoundingBoxImpl.prototype.computeFromVertices = function(vertices) {
        this.setFromPoints(vertices);
    };

    BoundingBoxImpl.prototype.compose = function(box) {
        this.union(box);
    };

    LANA3D.BoundingBox = function () {
        BoundingBoxImpl.call(this);
    };

    LANA3D.BoundingBox.prototype = BoundingBoxImpl.prototype;

    THREE.Box3 = LANA3D.BoundingBox;

}) (LANA3D || (LANA3D = {}));

/**
 * Base class for scene objects
 * @constructor
 */
LANA3D.Node = function () {
    Object.defineProperty(this, 'id', {
        get: this.getId
    });
    Object.defineProperty(this, 'name', {
        get: this.getName,
        set: this.setName
    });
    Object.defineProperty(this, 'parent', {
        get: this.getParent,
        set: this.setParent
    });
    Object.defineProperty(this, 'children', {
        get: this.getChildren
    });
    Object.defineProperty(this, 'localTransform', {
        get: this.getLocalTransform,
        set: this.setLocalTransform
    });
    Object.defineProperty(this, 'globalTransform', {
        get: this.getGlobalTransform
    });
    Object.defineProperty(this, 'enabled', {
        get: this.isEnabled,
        set: this.setEnabled
    });
};

LANA3D.Node.prototype = {

    /**
     * Gets node's id
     * @returns {int} id
     */
    getId: function () {},

    /**
     * Gets node's type
     * @returns {string} type
     */
    getType: function () {},

    /**
     * Gets node's name
     * @returns {string} name
     */
    getName: function() {},

    /**
     * Sets node's name
     * @param {string} name
     */
    setName: function (name) {},

    /**
     * Adds a node as its child
     * @param {LANA3D.Node} node Node to be added as child
     */
    addChild: function (node) {},

    /**
     * Removes a node from its children
     * @param {LANA3D.Node} node Node to be removed from children
     */
    removeChild: function (node) {},

    /**
     * Gets node children
     * @returns {Array.<LANA3D.Node>}
     */
    getChildren: function () {},

    /**
     * Gets node parent
     * @returns {LANA3D.Node}
     */
    getParent: function () {},

    /**
     * Sets node parent
     * @param {LANA3D.Node} node the parent
     */
    setParent: function (node) {},

    /**
     * Find children by name
     * @param {string} node name
     * @param {bool} if recursive
     * @returns {LANA3D.Node}
     */
    findChildrenByName: function (nodeName, recursive) {},

    /**
     * Find children by id
     * @param {int} node id
     * @param {bool} if recursive
     * @returns {LANA3D.Node}
     */
    findChildrenById: function (nodeName, recursive) {},

    /**
     * Find children by type
     * @param {type} variable type
     * @param {bool} if recursive
     * @returns {LANA3D.Node}
     */
    findChildrenByType: function (nodetype, recursive) {},

    getLocalTransform: function () {},

    setLocalTransform: function (transform) {},

    getGlobalTransform: function () {},

    rotate: function (angle, axis) {},

    translate: function (vector) {},

    scale: function(vector) {},

    clone: function() {},

    setEnabled: function(enabled) {},
    isEnabled: function() {},

    /**
    * Gets the axis aligned boundig box of the node and its children in the global coordinate system
    */
    getComposedAABB: function() {}
};

LANA3D.Node.findChildrenByType = function(node, type, recursive) {};
LANA3D.Node.findChildrenByName = function(node, name, recursive) {};


(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.Node;
        function NodeImpl() {
            _interface.apply ( this, arguments );
            ThreeImpl.Adapter.apply ( this, arguments );
            this._localTransform = new LANA3D.Transform(this);
         }
        NodeImpl.prototype = Object.create( LANA3D.Node.prototype);

        ThreeImpl.augment(NodeImpl, ThreeImpl.Adapter);

        NodeImpl.prototype.internalType = THREE.Object3D;

        NodeImpl.prototype.type = "node";

        NodeImpl.prototype.clone = function ( recursive ) {

            return LANA3D.NodeManager.createNode("node").copy( this, recursive );

        };

        NodeImpl.prototype.copy = function ( source, recursive ) {

            if ( recursive === undefined ) recursive = true;

            this._internal.name = source._internal.name;

            this._internal.up.copy( source._internal.up );

            this._internal.position.copy( source._internal.position );
            this._internal.quaternion.copy( source._internal.quaternion );
            this._internal.scale.copy( source._internal.scale );

            this._internal.matrix.copy( source._internal.matrix );
            this._internal.matrixWorld.copy( source._internal.matrixWorld );

            this._internal.matrixAutoUpdate = source._internal.matrixAutoUpdate;
            this._internal.matrixWorldNeedsUpdate = source._internal.matrixWorldNeedsUpdate;

            this._internal.layers.mask = source._internal.layers.mask;
            this._internal.visible = source._internal.visible;

            this._internal.castShadow = source._internal.castShadow;
            this._internal.receiveShadow = source._internal.receiveShadow;

            this._internal.frustumCulled = source._internal.frustumCulled;
            this._internal.renderOrder = source._internal.renderOrder;

            this._internal.userData = JSON.parse( JSON.stringify( source._internal.userData ) );

            this._localTransform = new LANA3D.Transform(this);

            if ( recursive === true ) {

                for ( var i = 0; i < source.getChildren().length; i ++ ) {

                    var child = source.getChildren()[ i ];
                    this.addChild( child.clone() );

                }

            }

            return this;

        }


        NodeImpl.prototype.getId = function () {
            return this.getInternal().id;
        };

        NodeImpl.prototype.getType = function () {
            return this.type;
        };

        NodeImpl.prototype.getName = function () {
            return this.getInternal().name;
        };

        NodeImpl.prototype.setName = function (name) {
            this.getInternal().name = name;
        };

        NodeImpl.prototype.addChild = function (node) {
            this.getInternal().add(node.getInternal());
        };

        NodeImpl.prototype.removeChild = function (node) {
            this.getInternal().remove(node.getInternal());
        };

        NodeImpl.prototype.getChildren = function () {
            var children = [];
            for (var i=0; i< this.getInternal().children.length; i++) {
                var child = LANA3D.NodeManager.getInstance().getNodeFromInternal(this.getInternal().children[i]);
                children.push(child);
            }
            return children;
        };

        NodeImpl.prototype.getParent = function () {
            return LANA3D.NodeManager.getInstance().getNodeFromInternal(this.getInternal().parent);
        };

        NodeImpl.prototype.setParent = function (node) {
            if (node instanceof LANA3D.Node) {
                node.getInternal().add(this.getInternal());
            } else if(this.getInternal().parent) {
                this.getInternal().parent.remove(this.getInternal());
            }
        };

        NodeImpl.prototype.findChildrenByName = function (nodeName, recursive) {
            var children = [];
            for (var i=0; i< this.getChildren().length; i++) {
                var child = this.getChildren()[i];
                if(child.getName() === nodeName)
                    children.push( child );
                if(recursive){
                    var recursive_childrens = child.findChildrenByName(nodeName, recursive);
                    for (var j=0; j< recursive_childrens.length; j++) {
                        children.push( recursive_childrens[j]);
                    }
                }
            }
            return children;
        };

        NodeImpl.prototype.findChildrenById = function (id, recursive) {
            for (var i=0; i< this.getChildren().length; i++) {
                var child = this.getChildren()[i];
                if(child.getId() === id)
                    return child;
                else if(recursive){
                    var recursive_child = child.findChildrenById(id, recursive);
                    if(recursive_child !== undefined)
                        return recursive_child;
                }
            }
            return;
        };

        NodeImpl.prototype.findChildrenByType = function (nodeType, recursive) {
            var children = [];
            for (var i=0; i< this.getChildren().length; i++) {
                var child = this.getChildren()[i];
                if(child.type === nodeType)
                    children.push( child );
                if(recursive){
                    var recursive_childrens = child.findChildrenByType(nodeType, recursive);
                    for (var j=0; j< recursive_childrens.length; j++) {
                        children.push( recursive_childrens[j]);
                    }
                }
            }
            return children;
        };

        NodeImpl.prototype.getLocalTransform = function (node) {
            return this._localTransform;
        };

        NodeImpl.prototype.setLocalTransform = function (transform) {
            var data = [ new THREE.Vector3(),new THREE.Quaternion(),new THREE.Vector3() ];
            transform.decompose(data[0], data[1], data[2]);
            this._localTransform.setPosition(data[0]);
            this._localTransform.setQuaternion(data[1]);
            this._localTransform.setScale(data[2]);
            this.getInternal().matrix.compose(data[0], data[1], data[2]);
            this.getInternal().updateMatrixWorld(true);
        };

        NodeImpl.prototype.rotate = function (angle, axis) {
            this.getInternal().rotateOnAxis(axis, angle);
        };

        NodeImpl.prototype.translate = function (vector) {
            this.getInternal().position.add(vector);
            this.getInternal().updateMatrix();
        };

        NodeImpl.prototype.scale = function(vector) {
            this.getInternal().scale.multiply(vector);
            this.getInternal().updateMatrix();
        };

        NodeImpl.prototype.setEnabled = function(enabled) {
            this.getInternal().visible = enabled;
        };
        
        NodeImpl.prototype.isEnabled = function() {
            return this.getInternal().visible;
        };

        NodeImpl.prototype.getComposedAABB = function() {
            var box = new LANA3D.BoundingBox();
            box.setFromObject(this.getInternal());
            return box;
        };

        LANA3D.Node = function () {
            NodeImpl.apply ( this, arguments );
        };

        LANA3D.Node.prototype = NodeImpl.prototype;

        LANA3D.Node.findChildrenByType = function(node, type, recursive) {
            var children = [];
            if(node.children){
                for (var i=0; i< node.children.length; i++) {
                    var child = node.children[i];
                    if(child.type === type)
                        children.push( child );
                    if(recursive){
                        var recursive_childrens = LANA3D.Node.findChildrenByType(node.children[i], type, recursive);
                        for (var j=0; j< recursive_childrens.length; j++) {
                            children.push( recursive_childrens[j]);
                        }
                    }
                }
            }
            return children;
        };
        LANA3D.Node.findChildrenByName = function(node, name, recursive) {
            var children = [];
            if(node.children){
                for (var i=0; i< node.children.length; i++) {
                    var child = node.children[i];
                    if(child.name === name)
                        children.push( child );
                    if(recursive){
                        var recursive_childrens = LANA3D.Node.findChildrenByName(node.children[i], name, recursive);
                        for (var j=0; j< recursive_childrens.length; j++) {
                            children.push( recursive_childrens[j]);
                        }
                    }
                }
            }
            return children;
        };

        LANA3D.NodeManager.getInstance().registerConstructor(LANA3D.Node);

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Class for the scene
 * @constructor
 * @augments LANA3D.Node
 */
LANA3D.Scene = function () {
    LANA3D.Node.apply ( this, arguments );
};

/**
 * Scene type identifier
 * @type string
 */
LANA3D.Scene.prototype.type = "scene";






(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.Scene;
        function SceneImpl(internal) {
            _interface.apply ( this, arguments );
        }
        SceneImpl.prototype = Object.create( LANA3D.Node.prototype);

        ThreeImpl.augment(SceneImpl, LANA3D.Scene);

        SceneImpl.prototype.internalType = THREE.Scene;

        SceneImpl.prototype.clone = function ( recursive ) {

            return LANA3D.NodeManager.createNode("scene").copy( this, recursive );

        };

        SceneImpl.prototype.copy = function( source, recursive ) {
            LANA3D.Node.prototype.copy.call( this, source, recursive );

            if ( source._internal.background !== null ) this._internal.background = source._internal.background.clone();
            if ( source._internal.fog !== null ) this._internal.fog = source._internal.fog.clone();
            if ( source._internal.overrideMaterial !== null ) this._internal.overrideMaterial = source._internal.overrideMaterial.clone();

            this._internal.autoUpdate = source._internal.autoUpdate;
            this._internal.matrixAutoUpdate = source._internal.matrixAutoUpdate;

            return this;
        };

        LANA3D.Scene = function () {
            SceneImpl.apply ( this, arguments );
        };

        LANA3D.Scene.prototype = SceneImpl.prototype;

        LANA3D.NodeManager.getInstance().registerConstructor(LANA3D.Scene);
            
    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Base class for cameras
 * @constructor
 * @augments LANA3D.Node
 */
LANA3D.Camera = function () {
    LANA3D.Node.apply ( this, arguments );
};

/**
 * Camera type idenfifier
 * @type string
 */
LANA3D.Camera.prototype.type = "camera";

/**
 * Gets camera projection matrix
 * @returns {LANA3D.Matrix4x4}
 */
LANA3D.Camera.prototype.getProjectionMatrix = function() {
};



(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.Camera;
        function CameraImpl() {
            _interface.apply ( this, arguments );
        }
        CameraImpl.prototype = Object.create( LANA3D.Node.prototype);

        ThreeImpl.augment(CameraImpl, LANA3D.Camera);

        CameraImpl.prototype.internalType = THREE.Camera;

        CameraImpl.prototype.getProjectionMatrix = function () {
            return this.getInternal().projectionMatrix;
        };

        LANA3D.Camera = function () {
            CameraImpl.apply ( this, arguments );
        };

        LANA3D.Camera.prototype = CameraImpl.prototype;

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Perspective camera class
 * @constructor
 * @augments LANA3D.Camera
 */
LANA3D.PerspectiveCamera = function () {
    LANA3D.Camera.apply ( this, arguments );
};

/**
 * Perspective camera type identifier
 * @type string
 */
LANA3D.PerspectiveCamera.prototype.type = "camera.perspective";

LANA3D.PerspectiveCamera.prototype.getAspectRatio = function() {};

LANA3D.PerspectiveCamera.prototype.setAspectRatio = function(aspect) {};



(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.PerspectiveCamera;
        function PerspectiveCameraImpl(internal) {
            this.internalConstructorArgs = [75, window.innerWidth / window.innerHeight, 0.1, 1000 ];
            _interface.apply ( this, arguments );
        }
        PerspectiveCameraImpl.prototype = Object.create( LANA3D.Camera.prototype);

        ThreeImpl.augment(PerspectiveCameraImpl, LANA3D.PerspectiveCamera);

        PerspectiveCameraImpl.prototype.internalType = THREE.PerspectiveCamera;

        LANA3D.PerspectiveCamera = function () {
            PerspectiveCameraImpl.apply ( this, arguments );
        };

        LANA3D.PerspectiveCamera.prototype = PerspectiveCameraImpl.prototype;

        LANA3D.NodeManager.getInstance().registerConstructor(LANA3D.PerspectiveCamera);
            
    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Class to perform rendering
 * @constructor
 */
LANA3D.Renderer = function (parameters) {
};

LANA3D.Renderer.prototype = {
    /**
     * Renders the scene
     */
    render: function() {
        throw new Error("Render.render() not implemented.");
    }
};

/**
 * Creates new renderer
 * @static
 * @returns {LANA3D.Renderer}
 */
LANA3D.Renderer.createRenderer = function (parameters) {};

(function (LANA3D) {
    (function (ThreeImpl) {

        function RendererImpl(parameters) {
            LANA3D.Renderer.apply ( this, arguments );

            if ( Detector.webgl ) {
                this._internal = new THREE.WebGLRenderer(parameters);
            } else {
                this._internal = new THREE.CanvasRenderer(parameters);
            }
            this._internal.setSize( window.innerWidth, window.innerHeight );
            document.body.appendChild( this._internal.domElement );

            this._scene = undefined;
            this._camera = undefined;
        }
        RendererImpl.prototype = Object.create( LANA3D.Renderer.prototype);

        RendererImpl.prototype.getInternal = function () {
            return this._internal;
        };

        RendererImpl.prototype.getScene = function () {
            return this._scene;
        };
        RendererImpl.prototype.setScene = function (scene) {
            if(scene instanceof LANA3D.Scene)
                this._scene = scene;
        };

        RendererImpl.prototype.getCamera = function () {
            return this._camera;
        };
        RendererImpl.prototype.setCamera = function (camera) {
            if(camera instanceof LANA3D.Camera)
                this._camera = camera;
        };

        RendererImpl.prototype.render = function() {
            this.getInternal().render(this.getScene().getInternal(), this.getCamera().getInternal());
        };
        
        function createRenderer(parameters) {
            return new RendererImpl(parameters);
        }
        
        LANA3D.Renderer.createRenderer = createRenderer;
        
    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));



/**
 * Class for mesh objects
 * @constructor
 * @augments LANA3D.Node
 */
LANA3D.Mesh = function () {
    LANA3D.Node.apply ( this, arguments );

    Object.defineProperty(this, 'material', {
        get: this.getMaterial,
        set: this.setMaterial
    });
};

/**
 * Mesh type identifier
 * @type string
 */
LANA3D.Mesh.prototype.type = "mesh";

/**
 * Gets mesh material
 * @returns {LANA3D.Material} the material
 */
LANA3D.Mesh.prototype.getMaterial = function () {};

/**
 * Sets mesh material
 * @param {LANA3D.Material} material
 */
LANA3D.Mesh.prototype.setMaterial = function (material) {};

(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.Mesh;
        function MeshImpl(internal, args) {
            if (args) {
                for(var j = 0; j < args.length; ++j) {
                    if(args[j] instanceof LANA3D.Geometry ||
                        args[j] instanceof LANA3D.Material) {
                        args[j] = args[j].getInternal();
                    }
                }
            }

            _interface.call ( this, internal, args );
        }
        MeshImpl.prototype = Object.create( LANA3D.Node.prototype);

        ThreeImpl.augment(MeshImpl, LANA3D.Mesh);

        MeshImpl.prototype.internalType = THREE.Mesh;

        MeshImpl.prototype.getGeometry = function () {
            return LANA3D.AssetManager.getInstance().getAssetFromInternal(this.getInternal().geometry);
        };
        MeshImpl.prototype.setGeometry = function (geometry) {
            this.getInternal().geometry = geometry.getInternal();
        };

        MeshImpl.prototype.getMaterial = function () {
            return LANA3D.AssetManager.getInstance().getAssetFromInternal(this.getInternal().material);
        };
        MeshImpl.prototype.setMaterial = function (material) {
            this.getInternal().material = material.getInternal();
        };

        MeshImpl.prototype.copy = function( source ) {

            LANA3D.Node.prototype.copy.call( this, source );

            this._internal.drawMode = source._internal.drawMode;

            return this;
        };

        MeshImpl.prototype.clone = function( ) {
            return LANA3D.NodeManager.createNode("mesh", this._internal.geometry, 
                this._internal.material ).copy( this );
        };

        LANA3D.Mesh = function () {
            MeshImpl.apply ( this, arguments );
        };

        LANA3D.Mesh.prototype = MeshImpl.prototype;

        LANA3D.NodeManager.getInstance().registerConstructor(LANA3D.Mesh);

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Class for joint objects
 * @constructor
 * @augments LANA3D.Node
 */
LANA3D.Joint = function () {
    LANA3D.Node.apply ( this, arguments );
};

/**
 * Joint type identifier
 * @type string
 */
LANA3D.Joint.prototype.type = "joint";


(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.Joint; 
        function JointImpl(internal) {
            _interface.apply ( this, arguments );
        }
        JointImpl.prototype = Object.create( LANA3D.Node.prototype);

        ThreeImpl.augment(JointImpl, LANA3D.Joint);

        JointImpl.prototype.internalType = THREE.Bone;

        JointImpl.prototype.copy = function( source ) {

            LANA3D.Node.prototype.copy.call( this, source );

            return this;
        };

        JointImpl.prototype.clone = function( ) {
            return LANA3D.NodeManager.createNode("joint").copy( this );
        };

        LANA3D.Joint = function () {
            JointImpl.apply ( this, arguments );
        };

        LANA3D.Joint.prototype = JointImpl.prototype;

        LANA3D.NodeManager.getInstance().registerConstructor(LANA3D.Joint);

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Class for mesh objects
 * @constructor
 * @augments LANA3D.Node
 */
LANA3D.SkinnedMesh = function () {
    LANA3D.Mesh.apply ( this, arguments );
};

/**
 * Mesh type identifier
 * @type string
 */
LANA3D.SkinnedMesh.prototype.type = "mesh.skinned";

/**
 * Gets skinnedmesh joints
 * @returns {Array.<LANA3D.Joint>}
 */
LANA3D.SkinnedMesh.prototype.getJoints = function () {};

/**
 * Sets skinnedmesh joints
 * @param {Array.<LANA3D.Joint>} joints
 */
LANA3D.SkinnedMesh.prototype.setJoints = function (joints) {};
(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.SkinnedMesh;
        function SkinnedMeshImpl(internal, args) {

            _interface.call ( this, internal, args );
        }
        SkinnedMeshImpl.prototype = Object.create( LANA3D.Mesh.prototype);

        ThreeImpl.augment(SkinnedMeshImpl, LANA3D.SkinnedMesh);

        SkinnedMeshImpl.prototype.internalType = THREE.SkinnedMesh;
        
        SkinnedMeshImpl.prototype.getJoints = function () {
            var joints = [];
            var _bones = this.getInternal().skeleton.bones;
            for (var i=0; i<_bones.length; i++) {
                joints.push(LANA3D.NodeManager.getInstance().getNodeFromInternal(_bones[i]));
            }
            return joints;
        };
        
        SkinnedMeshImpl.prototype.setJoints = function (joints) {
            this.getInternal().skeleton = new THREE.Skeleton( joints );
        };

        SkinnedMeshImpl.prototype.copy = function( source ) {

            LANA3D.Node.prototype.copy.call( this, source );

            this._internal.drawMode = source._internal.drawMode;

            for (var i = 0; i<source._internal.skeleton.boneInverses.length; ++ i) {
                this._internal.skeleton.boneInverses[i] = source._internal.skeleton.boneInverses[i];
            }

            return this;
        };

        SkinnedMeshImpl.prototype.clone = function( ) {
            return LANA3D.NodeManager.createNode("mesh.skinned", this._internal.geometry, 
                this._internal.material, this._internal.skeleton.useVertexTexture ).copy( this );
        };

        LANA3D.SkinnedMesh = function () {
            SkinnedMeshImpl.apply ( this, arguments );
        };

        LANA3D.SkinnedMesh.prototype = SkinnedMeshImpl.prototype;

        LANA3D.NodeManager.getInstance().registerConstructor(LANA3D.SkinnedMesh);
            
    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Base class for lights
 * @constructor
 * @augments LANA3D.Node
 */
LANA3D.Light = function () {
    LANA3D.Node.apply ( this, arguments );
};

/**
 * Light type identifier
 * @type string
 */
LANA3D.Light.prototype.type = "light";

(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.Light;
        function LightImpl() {
            _interface.apply ( this, arguments );
        }
        LightImpl.prototype = Object.create( LANA3D.Node.prototype);

        ThreeImpl.augment(LightImpl, LANA3D.Light);

        LightImpl.prototype.internalType = THREE.Light;

        LANA3D.Light = function () {
            LightImpl.apply ( this, arguments );
        };

        LANA3D.Light.prototype = LightImpl.prototype;

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Ambient light class
 * @constructor
 * @augments LANA3D.Light
 */
LANA3D.AmbientLight = function () {
    LANA3D.Light.apply ( this, arguments );
};

/**
 * Ambient light type identifier
 * @type string
 */
LANA3D.AmbientLight.prototype.type = "light.ambient";

(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.AmbientLight;
        function AmbientLightImpl() {
            _interface.apply ( this, arguments );
        }
        AmbientLightImpl.prototype = Object.create( LANA3D.Light.prototype);

        ThreeImpl.augment(AmbientLightImpl, LANA3D.AmbientLight);

        AmbientLightImpl.prototype.internalType = THREE.AmbientLight;

        LANA3D.AmbientLight = function () {
            AmbientLightImpl.apply ( this, arguments );
        };

        LANA3D.AmbientLight.prototype = AmbientLightImpl.prototype;

        LANA3D.NodeManager.getInstance().registerConstructor(LANA3D.AmbientLight);

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Directional light class
 * @constructor
 * @augments LANA3D.Light
 */
LANA3D.DirectionalLight = function () {
    LANA3D.Light.apply ( this, arguments );
};

/**
 * Directional light type identifier
 * @type string
 */
LANA3D.DirectionalLight.prototype.type = "light.directional";

(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.DirectionalLight;
        function DirectionalLightImpl() {
            _interface.apply ( this, arguments );
        }
        DirectionalLightImpl.prototype = Object.create( LANA3D.Light.prototype);

        ThreeImpl.augment(DirectionalLightImpl, LANA3D.DirectionalLight);

        DirectionalLightImpl.prototype.internalType = THREE.DirectionalLight;

        LANA3D.DirectionalLight = function () {
            DirectionalLightImpl.apply ( this, arguments );
        };

        LANA3D.DirectionalLight.prototype = DirectionalLightImpl.prototype;

        LANA3D.NodeManager.getInstance().registerConstructor(LANA3D.DirectionalLight);

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Hemisphere light class
 * @constructor
 * @augments LANA3D.Light
 */
LANA3D.HemisphereLight = function () {
    LANA3D.Light.apply ( this, arguments );
};

/**
 * Hemisphere light type identifier
 * @type string
 */
LANA3D.HemisphereLight.prototype.type = "light.hemisphere";

(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.HemisphereLight;
        function HemisphereLightImpl() {
            _interface.apply ( this, arguments );
        }
        HemisphereLightImpl.prototype = Object.create( LANA3D.Light.prototype);

        ThreeImpl.augment(HemisphereLightImpl, LANA3D.HemisphereLight);

        HemisphereLightImpl.prototype.internalType = THREE.HemisphereLight;

        LANA3D.HemisphereLight = function () {
           HemisphereLightImpl.apply ( this, arguments );
        };

        LANA3D.HemisphereLight.prototype = HemisphereLightImpl.prototype;

        LANA3D.NodeManager.getInstance().registerConstructor(LANA3D.HemisphereLight);

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Class to load bundles
 * @constructor
 */
LANA3D.BundleLoader = function () {
};


LANA3D.BundleLoader.prototype = {
    type: [],
    load: function (url, onLoad, onProgress, onError) {},
    parse: function (content) {}
};
/**
 * AssimpJSONAnimationLoader class
 * @constructor
 */
LANA3D.AssimpJSONLoader = function () {
    LANA3D.BundleLoader.apply ( this, arguments );
};

LANA3D.AssimpJSONLoader.prototype.texturePath = '';
LANA3D.AssimpJSONLoader.prototype.type = ['json'];
(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.AssimpJSONLoader;

        function AssimpJSONLoaderImpl() {
            _interface.apply ( this, arguments );
            this.setCrossOrigin('anonymous');
        }
        AssimpJSONLoaderImpl.prototype = Object.create( THREE.AssimpJSONLoader.prototype);

        ThreeImpl.augment(AssimpJSONLoaderImpl, LANA3D.BundleLoader);
        ThreeImpl.augment(AssimpJSONLoaderImpl, LANA3D.AssimpJSONLoader);


        AssimpJSONLoaderImpl.prototype.type = ["json"];

        AssimpJSONLoaderImpl.prototype.loadJSON = function (path, callback) {

            var xobj = new XMLHttpRequest();
            xobj.overrideMimeType("application/json");

            if ( this.crossOrigin !== undefined ) xobj.crossOrigin = this.crossOrigin;

            xobj.open('GET', path, true); // Replace 'my_data' with the path to your file
            xobj.onreadystatechange = function () {
                  if (xobj.readyState == 4 && xobj.status == "200") {
                    // Required use of an anonymous callback as .open will NOT return a value but simply returns undefined in asynchronous mode
                    callback(xobj.responseText);
                  }
            };
            xobj.send(null);
        };

	AssimpJSONLoaderImpl.prototype.load = function ( url, onLoad, onProgress, onError, texturePath ) {

		var scope = this;

		scope.loadJSON(url, function(text) {
			var json = JSON.parse( text ), scene, metadata;

            scope.texturePath = texturePath && ( typeof texturePath === "string" ) ? texturePath : scope.extractUrlBase( url );

			// Check __metadata__ meta header if present
			// This header is used to disambiguate between
			// different JSON-based file formats.
			metadata = json.__metadata__;
			if ( typeof metadata !== 'undefined' )
			{
				// Check if assimp2json at all
				if ( metadata.format !== 'assimp2json' ) {
					onError('Not an assimp2json scene');
					return;
				}
				// Check major format version
				else if ( metadata.version < 100 && metadata.version >= 200 ) {
					onError('Unsupported assimp2json file format version');
					return;
				}
			}

			scene = scope.parse( json );
			onLoad( scene );
		}, onProgress, onError );
	};

	AssimpJSONLoaderImpl.prototype.parse = function ( json ) {
            var meshes = null;
            if(json.meshes){
                meshes = this.parseList ( json.meshes, this.parseMesh );
            }
            var materials = null;
            if(json.materials){
                materials = this.parseList ( json.materials, this.parseMaterial );
            }
            //parse scene objects
            var scene = this.parseObject( json, json.rootnode );
            scene.updateMatrixWorld(true);

            //parse scene meshes
            if(json.meshes){
                var isSkinned = false;
                var gbones = {bones: [], boneInverses: []};
                for (var i = 0; i < json.meshes.length; ++ i)
                {
                    if(json.meshes[i].bones){
                        this.parseSkinnedMesh(json.meshes[i], meshes[i], scene, gbones);
                        materials[json.meshes[i].materialindex].skinning = true;
                        isSkinned = true;
                    }
                    meshes[i].materialindex = json.meshes[i].materialindex;
                }
                if(isSkinned){
                    scene.skeleton = new THREE.Skeleton(gbones.bones, gbones.boneInverses, false);
                }
            }
            this.parseMeshes( scene, meshes, materials, scene.skeleton, json);

            var animations  = [];
            if(json.animations){
                for (var i = 0; i < json.animations.length; ++ i)
                {
                    animations.push(this.parseAnimation(json.animations[i], json.rootnode));
                }
            }
            scene.animations = animations;
            scene.updateMatrixWorld(true);
            return scene;
	};

    AssimpJSONLoaderImpl.prototype.parseMaterial = function ( json ){

        var mat = null;
        var scope = this;
        var transparent = false;
        var prop, has_textures = [],

        init_props = {
            shading : THREE.SmoothShading
        };

        function toColor( value_arr ) {

            var col = new THREE.Color();
            col.setRGB( value_arr[ 0 ], value_arr[ 1 ], value_arr[ 2 ] );
            return col;

        }

        function defaultTexture() {

            var im = new Image();
            im.width = 1;
            im.height = 1;
            return new THREE.Texture( im );

        }

        for ( var i=0; i<json.properties.length; i++ ) {

            prop = json.properties[ i ];

            if ( prop.key === '$tex.file' ) {

                // prop.semantic gives the type of the texture
                // 1: diffuse
                // 2: specular mao
                // 5: height map (bumps)
                // 6: normal map
                // more values (i.e. emissive, environment) are known by assimp and may be relevant
                if ( prop.semantic === 1 || prop.semantic === 5 || prop.semantic === 6 || prop.semantic === 2 ) {

                    ( function( semantic ) {

                        var loader = new THREE.TextureLoader( scope.manager ),
                        keyname;

                        if ( semantic === 1 ) {

                            keyname = 'map';

                        } else if ( semantic === 5 ) {

                            keyname = 'bumpMap';

                        } else if ( semantic === 6 ) {

                            keyname = 'normalMap';

                        } else if ( semantic === 2 ) {

                            keyname = 'specularMap';

                        }

                        has_textures.push( keyname );

                        loader.setCrossOrigin( this.crossOrigin );
                        var material_url = scope.texturePath + '/' + prop.value;
                        material_url = material_url.replace( /\\/g, '/' );
                        loader.load( material_url, function( tex ) {

                            if ( tex ) {

                                // TODO: read texture settings from assimp.
                                // Wrapping is the default, though.
                                tex.wrapS = tex.wrapT = THREE.RepeatWrapping;

                                mat[ keyname ] = tex;
                                mat.needsUpdate = true;

                            }

                        } );

                    } )( prop.semantic );

                }

            } else if ( prop.key === '?mat.name' ) {

                init_props.name = prop.value;

            } else if ( prop.key === '$clr.diffuse' ) {

                init_props.color = toColor( prop.value );

            } else if ( prop.key === '$clr.specular' ) {

                init_props.specular = toColor( prop.value );

            } else if ( prop.key === '$clr.emissive' ) {

                init_props.emissive = toColor( prop.value );

            } else if ( prop.key === '$mat.shadingm' ) {

                // aiShadingMode_Flat
                if ( prop.value === 1 ) {

                    init_props.shading = THREE.FlatShading;

                }

            } else if ( prop.key === '$mat.shininess' ) {

                init_props.shininess = prop.value;

            } else if( prop.key === '$clr.transparent') {

               // init_props.transparent = prop.value;
                var transparencyLevel = (prop.value[0] + prop.value[1] + prop.value[2]) / 3 * prop.value[3];
                if (transparencyLevel > 0) {
                    init_props.transparent = true;
                    init_props.opacity = 1 - transparencyLevel;

                }

            } else if( prop.key === '$mat.opacity') {

                init_props.opacity = prop.value;

            }

        }

        // note: three.js does not like it when a texture is added after the geometry
        // has been rendered once, see http://stackoverflow.com/questions/16531759/.
        // for this reason we fill all slots upfront with default textures
        if ( has_textures.length ) {

            for ( i = has_textures.length - 1; i >= 0; -- i ) {

                init_props[ has_textures[ i ]] = defaultTexture();

            }

        }

        mat = new THREE.MeshPhongMaterial( init_props );
        return mat;

    };

    AssimpJSONLoaderImpl.prototype.findSkeletonBones = function (in_bones, scene, sortedBones, gbones){
            var scope = this;
            var bones = [];
            function findSceneBone(node, boneName){
                var nodename = node.name;
                if(node.name.indexOf('_$Assimp')!==-1)
                   nodename = node.name.substring(0,node.name.indexOf("_$Assimp"));
                if(nodename===boneName)
                {
                    return node;
                }
                if(node.children===undefined)
                    return undefined;
                for (var i = 0; i < node.children.length; ++ i) {
                    var n = findSceneBone(node.children[i], boneName);
                    if(n!==undefined)
                        return n;
                }
                return undefined;
            }
            function findPosInBoneList(bones, name){
                for(var j=0;j<bones.length;j++)
                {
                    if(bones[j].name===name){
                        return j;
                    }
                }
                return -1;
            }

            function findInBoneList(bones, name){
                for(var j=0;j<bones.length;j++)
                {
                    if(bones[j].name===name){
                        return bones[j];
                    }
                }
                return undefined;
            }

            for (var i = 0; i < in_bones.length; ++ i) {
                var sortedBone = {matrix: LANA3D.Matrix4x4(), offsetmatrix: LANA3D.Matrix4x4(), name:'', 
                    parent:-1, pos: Array(0,0,0), rotq: Array(0,0,0,1), scl: Array(1,1,1) };
                var offsetmatrix =  new LANA3D.Matrix4x4().fromArray(in_bones[i].offsetmatrix).transpose();
                sortedBone.name = in_bones[i].name;
                sortedBone.offsetmatrix = offsetmatrix;
                sortedBones.push(sortedBone);
                var bone = findInBoneList(gbones.bones, in_bones[i].name);
                if(bone === undefined){
                    //bone = new THREE.Bone();
                    bone = findSceneBone(scene, in_bones[i].name);
                    gbones.bones.push(bone);
                    gbones.boneInverses.push(offsetmatrix);
                }
                bone.name = in_bones[i].name;   
                bones.push(bone);             
            }

            function linkBones(bones, sortedBones, gbones){
                function copyTranformation(orig, dest, sortedDest){                        
                    dest.matrix = orig.matrix;
                    var data = [ new THREE.Vector3(),new THREE.Quaternion(),new THREE.Vector3() ];
                    dest.matrix.decompose( data[0], data[1], data[2] );
                    dest.position.set(data[0].x, data[0].y, data[0].z);
                    dest.quaternion.set(data[1].x, data[1].y, data[1].z, data[1].w);
                    dest.scale.set(data[2].x, data[2].y, data[2].z);

                    sortedDest.matrix = dest.matrix;
                    sortedDest.pos[0] = data[0].x; 
                    sortedDest.pos[1] = data[0].y; 
                    sortedDest.pos[2] = data[0].z;
                    sortedDest.rotq[0] = data[1].x; 
                    sortedDest.rotq[1] = data[1].y; 
                    sortedDest.rotq[2] = data[1].z; 
                    sortedDest.rotq[3] = data[1].w;
                    sortedDest.scl[0] = data[2].x; 
                    sortedDest.scl[1] = data[2].y; 
                    sortedDest.scl[2] = data[2].z;
                }
            
                var needUpdateBoneList = false;
                for (var s = 0; s < bones.length; ++ s) 
                {    
                    var index = s;
                    var sceneBone = findSceneBone(scene, bones[s].name);
                    if(sceneBone.parent.name===scene.name || bones[s].name===gbones.bones[0].name){
                        //sceneBone.parent.add(bones[s]);
                    }else{

                        var boneParent = findInBoneList(bones, sceneBone.parent.name);
                        if(boneParent===undefined){
                            boneParent = findSceneBone(scene, sceneBone.parent.name);     
                            var sortedBone = {matrix: new LANA3D.Matrix4x4(), offsetmatrix: new LANA3D.Matrix4x4(), name:'', parent:-1, pos: Array(0,0,0), rotq: Array(0,0,0,1), scl: Array(1,1,1) };
                            sortedBone.name = boneParent.name;
                            
                            sortedBones.splice(s, 0, sortedBone);
                            bones.splice(s, 0, boneParent);

                            var mainListBoneParent = findInBoneList(gbones.bones, sceneBone.parent.name);
                            if(mainListBoneParent===undefined)
                            {
                                gbones.bones.splice(s, 0, boneParent);
                                gbones.boneInverses.splice(s, 0, new LANA3D.Matrix4x4());
                            }

                            needUpdateBoneList = true;

                            s--;
                            index++;               
                        }else{
                            sortedBones[s].parent = findPosInBoneList(gbones.bones, boneParent.name);
                        }
                    }

                    copyTranformation(sceneBone, bones[index], sortedBones[index]);
                }

                if(needUpdateBoneList){
                    //relink the new list
                    linkBones(bones, sortedBones, gbones);
                }
            }
            linkBones(bones, sortedBones, gbones);

            return 
    };

        AssimpJSONLoaderImpl.prototype.parseSkinnedMesh = function(json, geometry, scene, gbones) {
            
            var sortedBones = [];
            this.findSkeletonBones(json.bones, scene, sortedBones, gbones);      
            geometry.bones = sortedBones;

            geometry.computeFaceNormals();
            geometry.computeBoundingSphere();

            function convertSkin(in_bones, sortedBones, out_skinWeights, out_skinIndices) {                        
                function getBoneId(boneList, boneName)
                {
                    for (var i = 0; i < boneList.length; i++) {
                        if(boneList[i].name===boneName)
                            return i;
                    }
                    return 0;
                }
                for (var i = 0; i < in_bones.length; i++) {
                    var boneId = getBoneId(sortedBones, in_bones[i].name);
                    for(var weightId=0;weightId< in_bones[i].weights.length;weightId++)
                    {
                        var weight = in_bones[i].weights[weightId];
                        if(out_skinWeights[weight[0]].x===0){
                            out_skinWeights[weight[0]].x = weight[1];
                            out_skinIndices[weight[0]].x = boneId;
                            continue;
                        }
                        if(out_skinWeights[weight[0]].y===0){
                            out_skinWeights[weight[0]].y = weight[1];
                            out_skinIndices[weight[0]].y = boneId;
                            continue;
                        }
                        if(out_skinWeights[weight[0]].z===0){
                            out_skinWeights[weight[0]].z = weight[1];
                            out_skinIndices[weight[0]].z = boneId;
                            continue;
                        }
                        if(out_skinWeights[weight[0]].w===0){
                            out_skinWeights[weight[0]].w = weight[1];
                            out_skinIndices[weight[0]].w = boneId;
                            continue;
                        }
                    }
                }
            }

            for (var i = 0; i < geometry.vertices.length; ++ i) {
                geometry.skinWeights.push(new THREE.Vector4(0,0,0,0));
                geometry.skinIndices.push(new THREE.Vector4(0,0,0,0));
            }
            convertSkin(json.bones, sortedBones, geometry.skinWeights, geometry.skinIndices);

            if ( geometry.bones && geometry.bones.length > 0 && ( geometry.skinWeights.length !== geometry.skinIndices.length || geometry.skinIndices.length !== geometry.vertices.length ) ) {

                    console.log( 'THREE.JSONLoader: When skinning, number of vertices (' + geometry.vertices.length + '), skinIndices (' +
                                    geometry.skinIndices.length + '), and skinWeights (' + geometry.skinWeights.length + ') should match.' );

            }

        };

	   AssimpJSONLoaderImpl.prototype.parseObject = function(json, node) {

            var obj = new THREE.Object3D();

            if(node.meshes){
                obj.meshes = node.meshes;

            }

            obj.name = node.name;
            obj.matrix = new THREE.Matrix4().fromArray(node.transformation).transpose();
            obj.matrix.decompose( obj.position, obj.quaternion, obj.scale );
            obj.matrixWorldNeedsUpdate = true;

            for (var i = 0; node.children && i < node.children.length; ++ i) {

                obj.add(this.parseObject(json, node.children[i]));

            }

            return obj;
	   };

       AssimpJSONLoaderImpl.prototype.parseMesh = function( json ) {

            var vertex, geometry, i, e, in_data, src;


            geometry = new THREE.Geometry();

            // read vertex positions
            for (in_data = json.vertices, i = 0, e = in_data.length; i < e; ) {
                geometry.vertices.push( new THREE.Vector3( in_data[ i ++ ], in_data[ i ++ ], in_data[ i ++ ] ) );
            }

            // read faces
            var cnt = 0;
            for (in_data = json.faces, i = 0, e = in_data.length; i < e; ++ i) {
                face = new THREE.Face3();
                src = in_data[i];
                face.a = src[0];
                face.b = src[1];
                face.c = src[2];

                face.materialIndex = 0; //json.materialindex;
                geometry.faces.push(face);
            }

            // read texture coordinates - three.js attaches them to its faces
            json.texturecoords = json.texturecoords || [];
            for (i = 0, e = json.texturecoords.length; i < e; ++ i) {

                function convertTextureCoords(in_uv, out_faces, out_vertex_uvs, numuvcomponents) {
                    var i, e, face, a, b, c;

                    for (i = 0, e = out_faces.length; i < e; ++ i) {
                        face = out_faces[i];
                        a = face.a * numuvcomponents;
                        b = face.b * numuvcomponents;
                        c = face.c * numuvcomponents;
                        out_vertex_uvs.push([
                            new THREE.Vector2( in_uv[ a ], in_uv[ a + 1 ] ),
                            new THREE.Vector2( in_uv[ b ], in_uv[ b + 1 ] ),
                            new THREE.Vector2( in_uv[ c ], in_uv[ c + 1 ] )
                        ]);
                    }
                }
                if(!geometry.faceVertexUvs[i])
                    geometry.faceVertexUvs[i] = [];

                convertTextureCoords(json.texturecoords[i], geometry.faces, geometry.faceVertexUvs[i], json.numuvcomponents[i]);
            }

            // read normals - three.js also attaches them to its faces
            if (json.normals) {

                function convertNormals(in_nor, out_faces) {
                    var i, e, face, a, b, c;

                    for (i = 0, e = out_faces.length; i < e; ++ i) {
                        face = out_faces[i];
                        a = face.a * 3;
                        b = face.b * 3;
                        c = face.c * 3;
                        face.vertexNormals = [
                            new THREE.Vector3( in_nor[ a ], in_nor[ a + 1 ], in_nor[ a + 2 ] ),
                            new THREE.Vector3( in_nor[ b ], in_nor[ b + 1 ], in_nor[ b + 2 ] ),
                            new THREE.Vector3( in_nor[ c ], in_nor[ c + 1 ], in_nor[ c + 2 ] )
                        ];
                    }
                }

                convertNormals(json.normals, geometry.faces);
            }

            // read vertex colors - three.js also attaches them to its faces
            if (json.colors && json.colors[0]) {

                function convertColors(in_color, out_faces) {
                    var i, e, face, a, b, c;

                    function makeColor(start) {
                        var col = new THREE.Color( );
                        col.setRGB( in_color[start], in_color[start + 1], in_color[start + 2] );
                        // TODO: what about alpha?
                        return col;
                    }

                    for (i = 0, e = out_faces.length; i < e; ++ i) {
                        face = out_faces[i];
                        a = face.a * 4;
                        b = face.b * 4;
                        c = face.c * 4;
                        face.vertexColors = [
                            makeColor( a ),
                            makeColor( b ),
                            makeColor( c )
                        ];
                    }
                }

                convertColors(json.colors, geometry.faces);
            }


            //geometry.computeFaceNormals();
            //geometry.computeVertexNormals();
            //geometry.computeTangents();
            geometry.computeBoundingSphere();

            // TODO: tangents
            return geometry;

        };

       AssimpJSONLoaderImpl.prototype.parseMeshes = function(node, meshes, materials, skeleton, json) {
        
            var obj = node;

            if(node.meshes!=undefined && meshes!==null){
                var meshID = obj.meshes;
                for (var id = 0; id<meshID.length; ++ id) 
                {
                    var mesh;
                    if (meshes[meshID[id]].faces[0].vertexColors.length > 0 ) {
                        materials[json.meshes[meshID[id]].materialindex].vertexColors = 2;
                    }

                    if(meshes[meshID[id]].skinIndices.length>0){
                        mesh = new THREE.SkinnedMesh( meshes[meshID[id]], materials[json.meshes[meshID[id]].materialindex], false);
                        for (var i = 0; i<mesh.skeleton.boneInverses.length; ++ i) {
                             for (var j = 0; j<skeleton.boneInverses.length; ++ j) {
                                 if(mesh.skeleton.bones[i].name===skeleton.bones[j].name){
                                    mesh.skeleton.boneInverses[i] = skeleton.boneInverses[j];
                                 }
                            }
                        }
                        //mesh.bind(skeleton, mesh.matrixWorld);
                    }else{
                        mesh = new THREE.Mesh( meshes[meshID[id]], materials[json.meshes[meshID[id]].materialindex] );
                    }

                    mesh.name = node.name + id;
                    node.add(mesh);
                }
            }

            var children = obj.children.slice();

            for (var i = 0; i < children.length; ++ i) {

                this.parseMeshes(children[i], meshes, materials, skeleton, json);

            }
       };

        AssimpJSONLoaderImpl.prototype.parseAnimation = function(json, rootnode) {
            var animation = {rootName : "", name : json.name, data : null};
            var data = { hierarchy : [], name : json.name, length : json.duration / json.tickspersecond, fps : json.tickspersecond};
            var channelsLength = json.channels.length;
            for(var i = 0; i < channelsLength; i++)
            {
                var obj = { name : '', keys : []};

                var nodename = json.channels[i].name;
                //  if(json.channels[i].name.indexOf('_$Assimp')!==-1){
                //      nodename = json.channels[i].name.substring(0,json.channels[i].name.indexOf("_$Assimp"));
                //  }

                //check if the node exist in the hierarchy list
                var j;
                var nodeExist = false;
                for(j = 0; j < data.hierarchy.length; j++)
                {
                    if(data.hierarchy[j].name === nodename){
                        nodeExist = true;
                        break;
                    }
                }

                if(nodeExist){
                    obj = data.hierarchy[j];
                }else{
                    obj.name = nodename;
                    data.hierarchy.push(obj);
                }

             //   if(json.channels[i].name.indexOf('_Translation')!==-1){
                    var positionkeysLength = json.channels[i].positionkeys.length;
                    for(j = 0; j < positionkeysLength; j++)
                    {
                        var time = json.channels[i].positionkeys[j][0] / json.tickspersecond;
                        var pos = new THREE.Vector3(json.channels[i].positionkeys[j][1][0],
                                             json.channels[i].positionkeys[j][1][1],
                                             json.channels[i].positionkeys[j][1][2]);
                        var position = new Array(pos.x,
                                             pos.y,
                                             pos.z);
                        var key = { time : 0, pos : new Array(0,0,0), rot : new THREE.Quaternion(), scl : Array(1,1,1), matrix: new LANA3D.Matrix4x4() };  
                        key.time = time;
                        key.pos = position;
                        var exist = false;
                        for(var keyindex = 0; keyindex < obj.keys.length; keyindex++){
                            if(obj.keys[keyindex].time === time){
                                obj.keys[keyindex].pos =  position;
                                obj.keys[keyindex].matrix.compose( new LANA3D.Vector3(obj.keys[keyindex].pos[0], obj.keys[keyindex].pos[1], obj.keys[keyindex].pos[2]),
                                                obj.keys[keyindex].rot,
                                                new LANA3D.Vector3(obj.keys[keyindex].scl[0], obj.keys[keyindex].scl[1], obj.keys[keyindex].scl[2]));
                                exist = true;
                                break;
                            }
                            if(obj.keys[keyindex].time > time){
                                exist = true;
                                if(keyindex>0){
                                    key.rot = obj.keys[keyindex-1].rot;
                                    key.scl = obj.keys[keyindex-1].scl;
                                }
                                key.matrix.compose( new LANA3D.Vector3(key.pos[0], key.pos[1], key.pos[2]),
                                                key.rot,
                                                new LANA3D.Vector3(key.scl[0], key.scl[1], key.scl[2]));
                                obj.keys.splice(keyindex, 0, key);
                                break;
                            }
                        }

                        if(!exist){
                            key.matrix.compose( new LANA3D.Vector3(key.pos[0], key.pos[1], key.pos[2]),
                                                key.rot,
                                                new LANA3D.Vector3(key.scl[0], key.scl[1], key.scl[2]));
                            obj.keys.push(key);
                        }
                    }
             //   }

             //   if(json.channels[i].name.indexOf('_Rotation')!==-1){
                    var rotationkeysLength = json.channels[i].rotationkeys.length;
                    for(j = 0; j < rotationkeysLength; j++)
                    {
                        var time = json.channels[i].rotationkeys[j][0] / json.tickspersecond;
                        var quat = new LANA3D.Quaternion(json.channels[i].rotationkeys[j][1][1],
                                                    json.channels[i].rotationkeys[j][1][2],
                                                    json.channels[i].rotationkeys[j][1][3],
                                                    json.channels[i].rotationkeys[j][1][0]);

                        var key = { time : 0, pos : new Array(0,0,0), rot : new THREE.Quaternion(), scl : Array(1,1,1), matrix: new LANA3D.Matrix4x4()  };
                        key.time = time;
                        key.rot = quat;
                        var exist = false;
                        for(var keyindex = 0; keyindex < obj.keys.length; keyindex++){
                            if(obj.keys[keyindex].time === time){
                                obj.keys[keyindex].rot = quat;
                                obj.keys[keyindex].matrix.compose( new LANA3D.Vector3(obj.keys[keyindex].pos[0], obj.keys[keyindex].pos[1], obj.keys[keyindex].pos[2]),
                                                obj.keys[keyindex].rot,
                                                new LANA3D.Vector3(obj.keys[keyindex].scl[0], obj.keys[keyindex].scl[1], obj.keys[keyindex].scl[2]));
                                exist = true;
                                break;
                            }
                            if(obj.keys[keyindex].time > time){
                                exist = true;
                                if(keyindex>0){
                                    key.pos = obj.keys[keyindex-1].pos;
                                    key.scl = obj.keys[keyindex-1].scl;
                                }
                                key.matrix.compose( new LANA3D.Vector3(key.pos[0], key.pos[1], key.pos[2]),
                                                key.rot,
                                                new LANA3D.Vector3(key.scl[0], key.scl[1], key.scl[2]));
                                obj.keys.splice(keyindex, 0, key);
                                break;
                            }
                        }

                        if(!exist){
                            key.matrix.compose( new LANA3D.Vector3(key.pos[0], key.pos[1], key.pos[2]),
                                                key.rot,
                                                new LANA3D.Vector3(key.scl[0], key.scl[1], key.scl[2]));
                            obj.keys.push(key);
                        }
                    }
            //    }

            //    if(json.channels[i].name.indexOf('_Scaling')!==-1){
                    var scalekeysLength = json.channels[i].scalingkeys.length;
                    for(j = 0; j < scalekeysLength; j++)
                    {
                        var time = json.channels[i].scalingkeys[j][0] / json.tickspersecond;
                        var scl = new THREE.Vector3(json.channels[i].scalingkeys[j][1][0],
                                          json.channels[i].scalingkeys[j][1][1],
                                          json.channels[i].scalingkeys[j][1][2]);
                        var scale = new Array(scl.x,
                                          scl.y,
                                          scl.z);

                        var key = { time : 0, pos : new Array(0,0,0), rot : new THREE.Quaternion(), scl : Array(1,1,1), matrix: new LANA3D.Matrix4x4()  };
                        key.time = time;
                        key.scl = scale;
                        var exist = false;
                        for(var keyindex = 0; keyindex < obj.keys.length; keyindex++){
                            if(obj.keys[keyindex].time === time){
                                obj.keys[keyindex].scl = scale;
                                obj.keys[keyindex].matrix.compose( new LANA3D.Vector3(obj.keys[keyindex].pos[0], obj.keys[keyindex].pos[1], obj.keys[keyindex].pos[2]),
                                                obj.keys[keyindex].rot,
                                                new LANA3D.Vector3(obj.keys[keyindex].scl[0], obj.keys[keyindex].scl[1], obj.keys[keyindex].scl[2]));
                                exist = true;
                                break;
                            }
                            if(obj.keys[keyindex].time > time){
                                if(keyindex>0){
                                    key.rot = obj.keys[keyindex-1].rot;
                                    key.pos = obj.keys[keyindex-1].pos;
                                }
                                key.matrix.compose( new LANA3D.Vector3(key.pos[0], key.pos[1], key.pos[2]),
                                                key.rot,
                                                new LANA3D.Vector3(key.scl[0], key.scl[1], key.scl[2]));
                                obj.keys.splice(keyindex, 0, key);
                                exist = true;
                                break;
                            }
                        }

                        if(!exist){
                            key.matrix.compose( new LANA3D.Vector3(key.pos[0], key.pos[1], key.pos[2]),
                                                key.rot,
                                                new LANA3D.Vector3(key.scl[0], key.scl[1], key.scl[2]));
                            obj.keys.push(key);
                        }
                    }
            //    }
            }

            animation.name = data.name;
            animation.rootName = rootnode.name;
            animation.data = data;

            return animation;
        };

        LANA3D.AssetManager.getInstance().registerBundleLoader(AssimpJSONLoaderImpl);

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));



/**
 * Class to export bundles
 * @constructor
 */
LANA3D.BundleExporter = function () {
};


LANA3D.BundleExporter.prototype = {
    type: [],
    export: function (scene, animations) {},
};
/**
 * AssimpJSONExporter class
 * @constructor
 */
LANA3D.AssimpJSONExporter = function () {
	LANA3D.BundleExporter.apply ( this, arguments );
};

LANA3D.AssimpJSONExporter.prototype.type = ['json'];
(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.AssimpJSONExporter;
        var _meshes = {};
        var _materials = {};
        var _animations = {};
        var _lights = {};
        var _cameras = {};

        function AssimpJSONExporterImpl() {
            _interface.apply ( this, arguments );
        }

        AssimpJSONExporterImpl.prototype = Object.create( LANA3D.BundleExporter.prototype);
        ThreeImpl.augment(AssimpJSONExporterImpl, LANA3D.AssimpJSONExporter);

        AssimpJSONExporterImpl.prototype.export = function (scene, animations) {

            _meshes = {};
            _materials = {};
            _animations = {};
            _lights = {};
            _cameras = {};

            var output = {
                    __metadata__: {
                        format: 'assimp2json',
                        version: 100,
                    }
            };
            output.flags = 0;
            output.rootnode = parseObject( scene.getInternal(), 'RootNode', output);
            output.animations = parseAnimations(animations, output);

            return output;
        };

        function parseMesh ( mesh, output ) {
            if ( output.meshes === undefined ) {
                output.meshes = [];
            }

            if ( _meshes[ mesh.uuid ] === undefined ) {

                var meshOutput = {
                    metadata: {
                        version: 0.1,
                        type: 'mesh',
                        generator: 'MeshExporter'
                    },
                    uuid: mesh.uuid,
                    type: mesh.type
                };

                meshOutput.name = mesh.name;
                for (var idm = 0; idm < output.materials.length; idm++) {
                    if (output.materials[idm].uuid === mesh.material.uuid) {
                        meshOutput.materialindex = idm;
                        break;
                    }
                }
                meshOutput.primitivetypes = 4;

                // parse vertex positions
                var vertices = [];
                for (var i = 0; i < mesh.geometry.vertices.length; i++ ) {
                    vertices.push( mesh.geometry.vertices[i].x );
                                vertices.push( mesh.geometry.vertices[i].y );
                                vertices.push( mesh.geometry.vertices[i].z );
                }
                meshOutput.vertices = vertices;

                var faces = [];
                var normals = new Array(vertices.length);
                var colors = new Array(vertices.length);
                var size = vertices.length;
                while(size--){ normals[size] = 0; colors[size] = 0;}

                var hasVertexUvs = mesh.geometry.faces.length === mesh.geometry.faceVertexUvs[0].length;

                var numuvcomponents, uvs;

                if (hasVertexUvs) {
                    if(mesh.geometry.faceVertexUvs[0][0][0] instanceof  THREE.Vector2)
                        numuvcomponents = 2;
                    else if(mesh.geometry.faceVertexUvs[0][0][0] instanceof THREE.Vector3){
                        numuvcomponents = 3;
                    }
                    uvs = new Array(mesh.geometry.faces.length*numuvcomponents*3);
                    size = mesh.geometry.faces.length;

                    while(size--) uvs[size] = 0;
                }


                for ( var i = 0; i < mesh.geometry.faces.length; i ++ ) {

                    var face = mesh.geometry.faces[ i ];

                    var hasMaterial = false; // face.materialIndex !== undefined;
                    var hasFaceUv = false; // deprecated
                    var hasFaceVertexUv = mesh.geometry.faceVertexUvs[ 0 ][ i ] !== undefined;
                    var hasFaceNormal = face.normal.length() > 0;
                    var hasFaceVertexNormal = face.vertexNormals.length > 0;
                    var hasFaceColor = face.color.r !== 1 || face.color.g !== 1 || face.color.b !== 1;
                    var hasFaceVertexColor = face.vertexColors.length > 0;

                    var faceType = 0;

                    faceType = setBit( faceType, 0, 0 );
                    faceType = setBit( faceType, 1, hasMaterial );
                    faceType = setBit( faceType, 2, hasFaceUv );
                    faceType = setBit( faceType, 3, hasFaceVertexUv );
                    faceType = setBit( faceType, 4, hasFaceNormal );
                    faceType = setBit( faceType, 5, hasFaceVertexNormal );
                    faceType = setBit( faceType, 6, hasFaceColor );
                    faceType = setBit( faceType, 7, hasFaceVertexColor );

                    //faces.push( faceType );
                    var f = [face.a, face.b, face.c ];
                    faces.push( f );


                    /*
                    if ( hasMaterial ) {

                        faces.push( face.materialIndex );

                    }
                    */

                    if ( hasFaceVertexUv ) {
                        var faceVertexUvs = mesh.geometry.faceVertexUvs[ 0 ][ i ];

                        setUvIndex( (face.a)*2, faceVertexUvs[ 0 ] );
                        setUvIndex( (face.b)*2, faceVertexUvs[ 1 ] );
                        setUvIndex( (face.c)*2, faceVertexUvs[ 2 ] );
                    }

                    if ( hasFaceVertexNormal ) {

                        var vertexNormals = face.vertexNormals;

                        setNormalIndex( (face.a)*3, vertexNormals[ 0 ] );
                        setNormalIndex( (face.b)*3, vertexNormals[ 1 ] );
                        setNormalIndex( (face.c)*3, vertexNormals[ 2 ] );
                    }

                    if ( hasFaceNormal &&  !hasFaceVertexNormal) {
                        setNormalIndex( face.a*3, face.normal );
                        setNormalIndex( face.b*3, face.normal );
                        setNormalIndex( face.c*3, face.normal );
                    }

                    if ( hasFaceVertexColor ) {

                        var vertexColors = face.vertexColors;

                        setColorIndex( face.a*4, vertexColors[ 0 ] );
                        setColorIndex( face.b*4, vertexColors[ 1 ] );
                        setColorIndex( face.c*4, vertexColors[ 2 ] );
                    }
                    if ( hasFaceColor & !hasFaceVertexColor ) {

                        setColorIndex( face.color ) ;

                        setColorIndex( face.a*4, face.color );
                        setColorIndex( face.b*4, face.color );
                        setColorIndex( face.c*4, face.color );
                    }
                }

                function setBit( value, position, enabled ) {
                    return enabled ? value | ( 1 << position ) : value & ( ~ ( 1 << position) );
                }

                function setNormalIndex( index, normal ) {
                    normals[index + 0] = normal.x;
                    normals[index + 1] = normal.y;
                    normals[index + 2] = normal.z;
                }

                function setColorIndex( index, color ) {
                    colors[index + 0] = color.r;
                    colors[index + 1] = color.g;
                    colors[index + 2] = color.b;
                }

                function setUvIndex( index, uv ) {
                    uvs[index] = uv.x;
                    uvs[index + 1] = uv.y;
                }

                meshOutput.normals = normals;
                if (hasVertexUvs) {
                    meshOutput.numuvcomponents = [];
                    meshOutput.numuvcomponents.push(numuvcomponents);
                    meshOutput.texturecoords = [];
                    meshOutput.texturecoords.push(uvs);
                }
                meshOutput.faces = faces;

                if(hasFaceVertexColor || hasFaceColor) {
                    meshOutput.colors = colors;
                }

                delete meshOutput.metadata;

                _meshes[ mesh.uuid ] = meshOutput;

                output.meshes.push( meshOutput );
            }

            return mesh.uuid;
        }

        function parseMaterial ( material, output ) {
            if ( output.materials === undefined ) {
                output.materials = [];
            }

            if ( _materials[ material.uuid ] === undefined ) {
                var materialOutput = {
                    metadata: {
                        version: 0.1,
                        type: 'material',
                        generator: 'MaterialExporter'
                    },
                    uuid: material.uuid,
                    type: material.type
                };

                var properties = [];

                //name
                var nameProp = {};
                nameProp.key = '?mat.name';
                nameProp.semantic = 0;
                nameProp.index = 0;
                nameProp.type = 3;
                nameProp.value = material.name;
                properties.push(nameProp);

                //diffuse
                if(material.color){
                    var diffuseProp = {};
                    diffuseProp.key = '$clr.diffuse';
                    diffuseProp.semantic = 0;
                    diffuseProp.index = 0;
                    diffuseProp.type = 1;
                    diffuseProp.value = [material.color.r, material.color.g, material.color.b];
                    properties.push(diffuseProp);
                }

                //emissive
                if(material.emissive){
                    var emissiveProp = {};
                    emissiveProp.key = '$clr.emissive';
                    emissiveProp.semantic = 0;
                    emissiveProp.index = 0;
                    emissiveProp.type = 1;
                    emissiveProp.value = [material.emissive.r, material.emissive.g, material.emissive.b];
                    properties.push(emissiveProp);
                }

                //ambient
                if(material.ambient){
                    var ambientProp = {};
                    ambientProp.key = '$clr.ambient';
                    ambientProp.semantic = 0;
                    ambientProp.index = 0;
                    ambientProp.type = 1;
                    ambientProp.value = [material.ambient.r, material.ambient.g, material.ambient.b];
                    properties.push(ambientProp);
                }

                //specular
                if(material.specular){
                    var specularProp = {};
                    specularProp.key = '$clr.specular';
                    specularProp.semantic = 0;
                    specularProp.index = 0;
                    specularProp.type = 1;
                    specularProp.value = [material.specular.r, material.specular.g, material.specular.b];
                    properties.push(specularProp);
                }

                //opacity
                if(material.opacity){
                    var opacityProp = {};
                    opacityProp.key = '$mat.opacity';
                    opacityProp.semantic = 0;
                    opacityProp.index = 0;
                    opacityProp.type = 1;
                    opacityProp.value = material.opacity;
                    properties.push(opacityProp);
                }

                //reflectivity
                if(material.reflectivity){
                    var reflectivityProp = {};
                    reflectivityProp.key = '$mat.reflectivity';
                    reflectivityProp.semantic = 0;
                    reflectivityProp.index = 0;
                    reflectivityProp.type = 1;
                    reflectivityProp.value = material.reflectivity;
                    properties.push(reflectivityProp);
                }

                //shininess
                if(material.shininess){
                    var shininessProp = {};
                    shininessProp.key = '$mat.shininess';
                    shininessProp.semantic = 0;
                    shininessProp.index = 0;
                    shininessProp.type = 1;
                    shininessProp.value = material.shininess;
                    properties.push(shininessProp);
                }

                if(material.map){
                    //texture file
                    var textFileProp = {};
                    textFileProp.key = '$tex.file';
                    textFileProp.semantic = 1;
                    textFileProp.index = 0;
                    textFileProp.type = 3;
                    textFileProp.value = material.map.image.src.replace(/^(?:\/\/|[^\/]+)*\//, "");
                    properties.push(textFileProp);

                    //texture uvtrafo
                    var textUVtrafoProp = {};
                    textUVtrafoProp.key = '$tex.uvtrafo';
                    textUVtrafoProp.semantic = 1;
                    textUVtrafoProp.index = 0;
                    textUVtrafoProp.type = 1;
                    textUVtrafoProp.value = [0,0,1,1,0];
                    properties.push(textUVtrafoProp);

                    //texture uvwsrc
                    var textUVwsrcProp = {};
                    textUVwsrcProp.key = '$tex.uvwsrc';
                    textUVwsrcProp.semantic = 1;
                    textUVwsrcProp.index = 0;
                    textUVwsrcProp.type = 4;
                    textUVwsrcProp.value = 0;
                    properties.push(textUVwsrcProp);
                }

                delete materialOutput.metadata;

                materialOutput.properties = properties;

                _materials[ material.uuid ] = materialOutput;

                output.materials.push( materialOutput );

            }

            return material.uuid;
        }

        function parseLight (object, output) {
            var data = {};

            if ( object instanceof THREE.DirectionalLight ) {
                data.type = 1;
                data.color = object.color.getHex();
                data.intensity = object.intensity;

            } else if ( object instanceof THREE.PointLight ) {
                data.type = 2;
                data.color = object.color.getHex();
                data.intensity = object.intensity;
                data.distance = object.distance;
                data.decay = object.decay;

            } else if ( object instanceof THREE.SpotLight ) {
                data.type = 3;
                data.color = object.color.getHex();
                data.intensity = object.intensity;
                data.distance = object.distance;
                data.angle = object.angle;
                data.exponent = object.exponent;
                data.decay = object.decay;

            } else {
                data = null;
            }

            if (data) {
                //light name must be unique
                var name = object.name;
                var i = 1;

                while(_lights[object.name]) {
                    object.name = name + i++;
                }
                data.name = object.name;

                _lights[object.name] = data;

                if ( output.lights === undefined ) {
                    output.lights = [];
                }
                output.lights.push(data);
            }

        }

        function parseCamera (object, output) {
            var data = {};

            if ( object instanceof THREE.PerspectiveCamera ) {

                data.fov = object.fov;
                data.aspect = object.aspect;
                data.near = object.near;
                data.far = object.far;

            } else if ( object instanceof THREE.OrthographicCamera ) {

                data.left = object.left;
                data.right = object.right;
                data.top = object.top;
                data.bottom = object.bottom;
                data.near = object.near;
                data.far = object.far;
            } else {
                data = null;
            }

            if(data) {
                //camera name must be unique
                var name = object.name;
                var i = 1;

                while(_cameras[object.name]) {
                    object.name = name + i++;
                }
                data.name = object.name;

                _cameras[object.name] = data;

                if ( output.cameras === undefined ) {
                    output.cameras = [];
                }
                output.cameras.push(data);
            }
        }

        function parseObject (object, name, output) {
            var data = {};

           // data.uuid = object.uuid;
           // data.type = object.type;
            data.name = name;

            if ( JSON.stringify( object.userData ) !== '{}' ) data.userData = object.userData;
            if ( object.visible !== true ) data.visible = object.visible;

            if ( object instanceof THREE.Camera ) {

                parseCamera(object, output);

            } else if ( object instanceof THREE.Light ) {

                parseLight(object, output);

            } else if ( object instanceof THREE.Mesh || object instanceof THREE.Line || object instanceof THREE.PointCloud ) {

                //delete data.name;
                parseMaterial( object.material, output );
                parseMesh( object, output );

                data.meshes = [];
                data.meshes.push(output.meshes.length-1);

                if ( object instanceof THREE.Line ) data.mode = object.mode;

            } else if ( object instanceof THREE.Animation ) {

                data.animation = parseAnimation( object.animation, output );

            } else if ( object instanceof THREE.Sprite ) {

                data.material = parseMaterial( object.material, output );

            }

            data.transformation = object.matrix.clone().transpose().toArray();

            if ( object.children.length > 0 ) {

                    data.children = [];

                    for ( var i = 0; i < object.children.length; i ++ ) {

                        data.children.push( parseObject( object.children[ i ], object.children[ i ].name, output ) );

                    }

            }

            return data;
        }

        function parseAnimations (animationlist) {
            var animations = [];
            for (var i = 0; i < animationlist.length; i++) {
                var animationClip = animationlist[i].getInternal();
                var animation = {};
                
                animation.name = animationClip.name;
                animation.tickspersecond =animationClip.fps;
                animation.duration = animationClip.length * animation.tickspersecond;
                
                var channels = [];
                
                for(var h = 0; h < animationClip.hierarchy.length;h++){
                    var channel = {};
                    if(animationClip.hierarchy[h].name=== undefined && animationClip.hierarchy[h].parent===-1)
                        channel.name =animationClip.rootnode;
                    else
                        channel.name = animationClip.hierarchy[h].name;
                    channel.prestate = 0;
                    channel.poststate = 0;
                    var positionkeys = [];
                    var rotationkeys = [];
                    var scalingkeys = [];
                    for(var k = 0; k < animationClip.hierarchy[h].keys.length;k++){
                        var key = animationClip.hierarchy[h].keys[k];
                        var positionkey = [];
                        var rotationkey = [];
                        var scalingkey = [];
                        positionkey.push(key.time*animation.tickspersecond); positionkey.push(key.pos);
                        rotationkey.push(key.time*animation.tickspersecond); rotationkey.push(new Array(key.rot._w, key.rot._x, key.rot._y, key.rot._z));
                        scalingkey.push(key.time*animation.tickspersecond); scalingkey.push(key.scl);
                        positionkeys.push(positionkey);
                        rotationkeys.push(rotationkey);
                        scalingkeys.push(scalingkey);
                    }
                    channel.positionkeys = positionkeys;
                    channel.rotationkeys = rotationkeys;
                    channel.scalingkeys = scalingkeys;
                    channels.push(channel);
                }
                animation.channels = channels;
                animations.push(animation);
            }
            return animations;
        }

        LANA3D.AssimpJSONExporter.prototype = AssimpJSONExporterImpl.prototype;

        LANA3D.AssetManager.getInstance().registerBundleExporter(LANA3D.AssimpJSONExporter);

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));



(function (LANA3D) {
    (function (ThreeImpl) {

        function glTFLoaderImpl() {
            THREE.glTFLoader.apply ( this, arguments );
        }

        glTFLoaderImpl.prototype = Object.create( THREE.glTFLoader.prototype);

        //ThreeImpl.augment(glTFLoaderImpl, LANA3D.BundleLoader);

        glTFLoaderImpl.prototype.type = ["gltf"];

        glTFLoaderImpl.prototype.load = function ( url, onLoad, onProgress, onError) {
            THREE.glTFLoader.prototype.load.call(this, url, function(scene){
                var result = scene.scene;
                result.animations = [];
                onLoad(result);
            });
        };

        LANA3D.AssetManager.getInstance().registerBundleLoader(glTFLoaderImpl);

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));



/**
 * ColladaLoader class
 * @constructor
 */
LANA3D.ColladaLoader = function () {    
    LANA3D.BundleLoader.apply ( this, arguments );
};

LANA3D.ColladaLoader.prototype = {
    
    texturePath : '',
    
    type : ['dae'],
    
    /**
    * Gets animation from json file
    * @returns {animation} anim
    */
    load: function ( url, onLoad, onProgress, onError, texturePath ) {},

    parse: function ( json ) {},
    
    parseSkin: function ( json ) {},
    
    parseList: function (json, handler) {},
    
    parseMesh: function (json) {},
    
    parseMaterial: function (json) {},
    
    parseAnimation: function (json) {},
    
    parseObject: function (json, node, meshes, materials) {}
};
(function (LANA3D) {
    (function (ThreeImpl) {
        var _interface = LANA3D.ColladaLoader; 
        
        function ColladaLoaderImpl() {
            _interface.apply ( this, arguments );
        }
        ColladaLoaderImpl.prototype = Object.create( THREE.ColladaLoader.prototype);
        
        ThreeImpl.augment(ColladaLoaderImpl, LANA3D.ColladaLoader);
        
        ColladaLoaderImpl.prototype.type = ["dae"];
        
        
	ColladaLoaderImpl.prototype.load = function ( url, onLoad, onProgress, onError, texturePath ) {
                
                var loader = new THREE.ColladaLoader();
                loader.options.convertUpAxis = true;
                loader.load( url, function ( collada ) {
                    var scene = collada.scene;  
                    scene.animations = [];
                    for (var daeGeometryId in collada.dae.geometries) {
                        var daeGeometry = collada.dae.geometries[daeGeometryId];
                       // result.assets.push(self.getAssetFromInternal(daeGeometry.mesh.geometry3js, daeGeometry.id));
                        if(daeGeometry.mesh.geometry3js.animation !== undefined) {
                            var animation = { data: undefined, name:'', rootName:''};
                            animation.data = daeGeometry.mesh.geometry3js.animation;
                            animation.name = daeGeometry.mesh.geometry3js.animation.name;
                            for (var i = 0; i < collada.skins.length; i++) {
                                var skin = collada.skins[i];
                                if (skin.geometry === daeGeometry.mesh.geometry3js) {
                                    //clip._loadedRootNode = LANA3D.NodeManager.getInstance().getNodeFromInternal(skin);
                                    animation.rootName = skin.parent.name;
                                }
                            }
                            scene.animations.push(animation);
                        }

                    }
                    onLoad( scene );
		}, onProgress, onError );
	};
        
        LANA3D.ColladaLoader.prototype = ColladaLoaderImpl.prototype;

        LANA3D.AssetManager.getInstance().registerBundleLoader(LANA3D.ColladaLoader);

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));



;
/**
 * AnimationClip asset class
 * @constructor
 * @augments LANA3D.Asset
 */
LANA3D.AnimationClip = function () {
    LANA3D.Asset.apply ( this, arguments );
};

LANA3D.AssetManager.prototype = {
    
    /**
    * AnimationClip type identifier
    * @type string
    */
   type: "animationclip",
   
   _name: '',
   
   _duration: 0,
   
   _ticksPerSecond: 25,
   
   _channels: [],
   
   /**
    * Gets animationclip name
    * @returns {string} name
    */
   getName: function () {},
   
   /**
    * Sets animationclip name
    * @param {string} name
    */
   setName: function ( name ) {},
   
   /**
    * Gets animationclip duration
    * @returns {double} duration time
    */
   getDuration: function () {},
   
   /**
    * Sets animationclip duration
    * @param {double} duration time
    */
   setDuration: function ( duration ) {},
   
   /**
    * Gets animationclip tick per second
    * @returns {double} ticks per second
    */
   getTicksPerSecond: function () {},
   
   /**
    * Sets animationclip tick per second
    * @param {double} tick per second
    */
    setTicksPerSecond: function ( duration ) {},
    
    /**
    * Gets animationclip number of channels
    * @returns {int} number of channels
    */
   getNumChannels: function () {},
   
   /**
    * Gets animationclip channel
    * @param {int} number of channel
    * @returns {AnimationChannel} animation channel
    */
   getChannel: function (number) {},
   
   /**
    * Gets animationclip channels
    * @returns {std::vector<AnimationChannel>} channels
    */
   getChannels: function () {},
   
   /**
    * Sets animationclip channels
    * @param {std::vector<AnimationChannel>} channels
    */
    setChannels: function ( channels ) {}
};
/**
 * AnimationChannel class
 * @constructor
 */
LANA3D.AnimationChannel = function () {    
    var AnimInterpolationType = {   AIT_UNKNOWN :    -1,	///< No parse value
                                    AIT_NONE :       0,		///< No value given
                                    AIT_STEP :       1,
                                    AIT_LINEAR :     2,
                                    AIT_BEZIER :     3};
    var tangentKey = {
        'mTime': 0.0, 
        'mValue': 0.0
    };
    
    var interpolationKey = {
        'mType': AnimInterpolationType.AIT_UNKNOWN, 
        'mInTangentValue': tangentKey,
        'mOutTangentValue': tangentKey
    };
    
    var interpolationKeyVector = {
        'mInterpolationX': interpolationKey, 
        'mInterpolationY': interpolationKey,
        'mInterpolationZ': interpolationKey
    };
    
    var vectorKey = {
        'mTime': 0.0, 
        'mValue': LANA3D.Vector3(0,0,0),
        'mInterpolation': interpolationKeyVector
    };
    
    var tangentQuat = {
        'mTime': 0.0, 
        'mValue': new THREE.Quaternion()
    };
    
    var interpolationQuat = {
        'mType': AnimInterpolationType.AIT_UNKNOWN, 
        'mInTangentValue': tangentQuat,
        'mOutTangentValue': tangentQuat
    };
    
    var quatKey = {
        'mTime': 0.0, 
        'mValue': new THREE.Quaternion(),
        'minterpolation': interpolationQuat
    };
    
};

LANA3D.AnimationChannel.prototype = {
    
    _nodeName: '',
    
    _traslationKeys: [],
    
    _scaleKeys: [],
    
    _rotationKeys: [],
    
    /**
    * Gets channel name
    * @returns {string} name
    */
    getName: function () {},

    /**
    * Sets channel name
    * @param {string} name
    */
    setName: function ( name ) {},
   
    /**
    * Gets traslationKeys 
    * @returns {vectorKeyVector} vector
    */
    getTraslationKeys: function () {},

    /**
    * Sets traslationKeys 
    * @param {vectorKeyVector} vector
    */
    setTraslationKeys: function ( traslationKeys ) {},
   
    /**
    * Gets scaleKeys 
    * @returns {vectorKeyVector} vector
    */
    getScaleKeys: function () {},

    /**
    * Sets scaleKeys 
    * @param {vectorKeyVector} vector
    */
    setScaleKeys: function ( scaleKeys ) {},
   
    /**
    * Gets rotationKeys 
    * @returns {quatKeyVector} vector
    */
    getRotationKeys: function () {},

    /**
    * Sets rotationKeys 
    * @param {quatKeyVector} vector
    */
    setRotationKeys: function ( rotationKeys ) {},
   
    /**
    * Get traslationKey 
    * @param {unsigned int} key id
    * @returns {vectorKey} key
    */
    getTraslationKey: function (keyId) {},
   
    /**
    * Get scaleKey 
    * @param {unsigned int} key id
    * @returns {vectorKey} key
    */
    getScaleKey: function (keyId) {},
   
    /**
    * Get rotationKey 
    * @param {unsigned int} key id
    * @returns {quatKey} key
    */
    getRotationKey: function (keyId) {},
   
    /**
    * Get number of traslation keys 
    * @returns {unsigned int} keyNum
    */
    getNumberOfTraslationKeys: function () {},
   
    /**
    * Get number of scale keys 
    * @returns {unsigned int} keyNum
    */
    getNumberOfScaleKeys: function () {},
   
    /**
    * Get number of rotation keys 
    * @returns {unsigned int} keyNum
    */
    getNumberOfRotationKeys: function () {},
    
    /**
    * Get traslation key time 
    * @param {unsigned int} key id
    * @returns {double} time
    */
    getTraslationKeyTime: function (keyId) {},
   
    /**
    * Get scale key time 
    * @param {unsigned int} key id
    * @returns {double} time
    */
    getScaleKeyTime: function (keyId) {},
   
    /**
    * Get rotation key time 
    * @param {unsigned int} key id
    * @returns {double} time
    */
    getRotationKeyTime: function (keyId) {}
};

(function (LANA3D) {
    (function (Impl) {
        var _interface = LANA3D.AnimationClip;
        function AnimationClipImpl() {
            _interface.apply ( this, arguments );
        }
        AnimationClipImpl.prototype = Object.create( LANA3D.Asset.prototype);

        AnimationClipImpl.prototype.type = 'animationclip';
        
        //Impl.augment(AnimationClipImpl, LANA3D.AnimationClip);
        
        AnimationClipImpl.prototype.getName = function () {
            return this._name;
        };
        AnimationClipImpl.prototype.setName = function ( name ) {
            this._name = name;
        };
        
        AnimationClipImpl.prototype.getDuration = function () {
            return this._duration;
        };
        AnimationClipImpl.prototype.setDuration = function ( duration ) {
            this._duration = duration;
        };
        
        AnimationClipImpl.prototype.getTicksPerSecond = function () {
            return this._ticksPerSecond;
        };
        AnimationClipImpl.prototype.setTicksPerSecond = function ( ticks ) {
            this._ticksPerSecond = ticks;
        };
        
        AnimationClipImpl.prototype.getNumChannels = function () {
            return this._channels.length;
        };
        
        AnimationClipImpl.prototype.getChannel = function (number) {
            return this._channels[number];
        };

        LANA3D.AnimationClip = function () {
            AnimationClipImpl.apply ( this, arguments );
        };
        
        AnimationClipImpl.prototype.getChannels = function () {
            return this._channels;
        };
        AnimationClipImpl.prototype.setChannels = function ( channels ) {
            this._channels = channels;
        };

        LANA3D.AnimationClip.prototype = AnimationClipImpl.prototype;

        LANA3D.AssetManager.getInstance().registerConstructor(LANA3D.AnimationClip);

    })(LANA3D.Impl || (LANA3D.Impl = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Manager class used to manage animations
 * @constructor
 */
LANA3D.AnimationManager = function () {
};

/**
 * Gets its instance
 * @static
 * @returns {LANA3D.AnimationManager}
 */
LANA3D.AnimationManager.getInstance = function() {
    
};

LANA3D.AnimationManager.prototype = {
    getHandler: function (node) {},
    
    getHandlers: function () {},
    
    destroyHandler: function (handler) {},
    
    createDefaultHandlers: function (node, animationClips) {},
    
    updateAnimations: function (deltaTimeMS) {}
};

/**
 * Gets animation handler for a node
 * @static
 * @param {LANA3D.Node} node
 * @return {LANA3D.AnimationHandler} handler
 */
LANA3D.AnimationManager.getHandler = function (node) {
    return LANA3D.AnimationManager.getInstance().getHandler(node);
};

/**
 * Gets animation handler for a node
 * @static
 * @return {Array.<LANA3D.AnimationHandler>} handlers
 */
LANA3D.AnimationManager.getHandlers = function () {
    return LANA3D.AnimationManager.getInstance().getHandlers();
};

/**
 * Gets animation handler for a node
 * @static
  * @param {LANA3D.AnimationHandler} handler
 */
LANA3D.AnimationManager.destroyHandler = function (handler) {
    LANA3D.AnimationManager.getInstance().destroyHandler(handler);
};

/**
 * Creates default animation handlers
 * @static
 * @param {LANA3D.Node} node
 * @param {} animationClips
 */
LANA3D.AnimationManager.createDefaultHandlers = function (node, animationClips) {
    return LANA3D.AnimationManager.getInstance().createDefaultHandlers(node, animationClips);
};

/**
 * Updates animations
 * @static
 * @param {float} delta time in milliseconds
 */
LANA3D.AnimationManager.updateAnimations = function (deltaTimeMS) {
    return LANA3D.AnimationManager.getInstance().updateAnimations(deltaTimeMS);
};

/**
 * Class to handle animations on a node
 * @constructor
 */
LANA3D.AnimationHandler = function () {
};

LANA3D.AnimationHandler.prototype = {
    
    /**
     * Gets root node
     * @returns {LANA3D.Node} root node
     */
    getRootNode: function () {},
    
    /**
     * Gets animation states
     * @returns {Array.<LANA3D.AnimationState>} animation states
     */
    getAnimationStates: function () {},
    
    /**
     * Gets animation state
     * @param {string} Animation state name
     * @returns {LANA3D.AnimationState} animation state
     */
    getAnimationState: function (name) {},
    
    /**
     * Sets root node
     * @param {LANA3D.Node} root node
     */
    setRootNode: function (node) {},
    
    /**
     * Create an AnimationState pointer and store it in a list with name provided
     * @param {string} Animation State name
     * @param {AnimationClip} Animation clip
     */
    addAnimationState: function (name, clip) {},
    
    /**
     * Unregister and Animation State pointer
     * @param {AnimationClip} Animation clip
     */
    removeAnimationState: function (clip) {},

    /**
     * Crossfade from one animation to another
     * @param {string} Origin animation name
     * @param {string} Dest animation name
     * @param {float} Crossfade duration time
     */
    crossfade: function ( fromAnimName,  toAnimName, duration) {}
};




(function (LANA3D) {
    (function () {
        var _interface = LANA3D.AnimationHandler; 
        function AnimationHandlerImpl(rootNode) {
            _interface.apply ( this, arguments );
            this._rootNode = rootNode;
            this._states = {};
            this._targets = [];
            this._weightSchedule = [];
            this._skeleton = undefined;
        }
        AnimationHandlerImpl.prototype = Object.create( LANA3D.AnimationHandler.prototype);


        AnimationHandlerImpl.prototype.getRootNode = function () {
            return this._rootNode;
        };
        
        AnimationHandlerImpl.prototype.getAnimationState = function (stateName) {
            var ret;
            for(var name in this._states) {
                if(name===stateName);
                ret = this._states[stateName];
            }
            return ret;
        };
        
        AnimationHandlerImpl.prototype.getAnimationStates = function () {
            var ret = [];
            for(var name in this._states) {
                ret.push(this._states[name]);
            }
            return ret;
        };
        
        AnimationHandlerImpl.prototype.setRootNode = function (node) {
            this._rootNode = node;
        };

        AnimationHandlerImpl.prototype.setSkeleton = function (skeleton) {
            this._skeleton = skeleton;
            var poses = [];
            var bones = this._skeleton.getInternal().bones;
            for(i = 0; i < bones.length ; i++)
            {
                var bonePose = new LANA3D.Matrix4x4;
                bonePose.multiply(bones[i].matrix) 
                poses.push(bonePose);
            }
            this._skeleton.poses = poses;
        };
        
        AnimationHandlerImpl.prototype.addAnimationState = function ( name, clip ) {
            var state = new LANA3D.AnimationState(name, clip, this._rootNode);
            this._states[name] = state;
            this.processAnimationStateList();
            return state;
        };
        
        AnimationHandlerImpl.prototype.removeAnimationState = function ( clip ) {
            for(var name in this._states) {
                if(name===clip.getName())
                    delete this._states[name];
            }
        };

        AnimationHandlerImpl.prototype.crossfade = function ( fromAnimName,  toAnimName, duration) {
            this._weightSchedule = [];
            for (var animName in this._states)
            {
                if (this._states[animName].getEnabled() &  animName != fromAnimName & animName != toAnimName)
                {
                    var closeSchedule = { state: this._states[animName], startWeight: this._states[animName].getWeight(), endWeight: 0, timeElapsed: 0, duration: 0.3 };
                    this._weightSchedule.push(closeSchedule);
                }
            }

            this._states[fromAnimName].setEnabled(true);
            this._states[toAnimName].setEnabled(true);

            var fromSchedule = { state: this._states[fromAnimName], startWeight: 1, endWeight: 0, timeElapsed: 0, duration: duration };
            this._weightSchedule.push(fromSchedule);

            var toSchedule = { state: this._states[toAnimName], startWeight: 0, endWeight: 1, timeElapsed: 0, duration: duration };
            this._weightSchedule.push(toSchedule);
        };
        
        AnimationHandlerImpl.prototype.update = function ( dtsec ) {

            var ret = false;
            
            //crossfade
            for (var i=0; i< this._weightSchedule.length; i++) {

                this._weightSchedule[i].timeElapsed += dtsec;

                // If the transition is complete, remove it from the schedule
                if (this._weightSchedule[i].timeElapsed > this._weightSchedule[i].duration) {

                    this._weightSchedule[i].state.setWeight(this._weightSchedule[i].endWeight);

                    // If we've faded out completely, stop the animation
                    if (this._weightSchedule[i].state.getWeight() === 0) {
                        this._weightSchedule[i].state.setEnabled(false);
                    }

                    this._weightSchedule.splice(i,1);
                    i--;
                }
                else {

                    // interpolate the weight for the current time
                    this._weightSchedule[i].state.setWeight(
                        this._weightSchedule[i].startWeight + (this._weightSchedule[i].endWeight - this._weightSchedule[i].startWeight) * this._weightSchedule[i].timeElapsed / this._weightSchedule[i].duration
                        );

                }

            }

            //check weights and normalize it
            var weightSum = 0.0;
            var activeStates = 0;
            for(var name in this._states)   
            {
                if(this._states[name].getEnabled())
                {
                    activeStates++;
                    weightSum += this._states[name].getWeight();
                }
            }

            var final_channels = {};	
            // Get all transforms into animation states
            for(var name in this._states)	
            {
                if(!this._states[name].getEnabled())
                    continue;

                ret = true;

                // Update data	
		        var map = this._states[name].update(dtsec);
                var weight = this._states[name].getWeight() / weightSum;
                var layer = this._states[name].getLayer();

                // For each joint, add (Animation State transform * weight)
                for(var nodeName in map)	
                {
                    var mat = map[nodeName];
                    if(final_channels[nodeName]===undefined){
                        final_channels[nodeName] = { mat: new LANA3D.Matrix4x4, layer: 0, weight: 0 };
                        final_channels[nodeName].mat = mat.multiplyScalar(weight);
                        final_channels[nodeName].layer = layer;
                        final_channels[nodeName].weight = weight;
                    }else{
                        if (final_channels[nodeName].layer < layer){
                            final_channels[nodeName].mat = mat.multiplyScalar(weight);
                            final_channels[nodeName].weight = weight;
                            final_channels[nodeName].layer = layer;
                        }else if(final_channels[nodeName].layer === layer){
                            final_channels[nodeName].mat.add(mat.multiplyScalar(weight));
                            final_channels[nodeName].weight += weight;
                        }
                    }
                }
            }

            for(var target in final_channels)
            {
                var find = false;
                for(var i=0;i<this._targets.length;i++){
                    if(target === this._targets[i].getName())
                    {
                        find = true;
                        var finalMat = new LANA3D.Matrix4x4;
                        finalMat.fromArray(final_channels[target].mat.elements);
                        if(this._skeleton != undefined && final_channels[target].weight != 1){
                            function getSkeletonBonePose(skeleton, boneName){
                                var bonePos = new LANA3D.Matrix4x4;
                                var bones = skeleton.getInternal().bones;
                                for(var b=0;b<bones.length;b++)
                                {
                                    if(bones[b].name===boneName){
                                        bonePos.fromArray(skeleton.poses[b].elements);
                                        break;
                                    }
                                }
                                return bonePos;
                            }
                            var boneMat = getSkeletonBonePose(this._skeleton, target);
                            boneMat = boneMat.multiplyScalar(1 - final_channels[target].weight);
                            boneMat.add(final_channels[target].mat);
                            finalMat = boneMat;
                        }
                        this._targets[i].setLocalTransform(finalMat);
                    }
                }
		
                if(!find)
                {
                    console.log('Animation handler no find target to update: '+ target + '.');
                    //error to report? aardanza
                }
            }

            return ret;
        };
        
         AnimationHandlerImpl.prototype.processAnimationStateList = function (){
            if(this._rootNode === undefined )
            {
                console.log("Can´t buildTargetReference(), _rootNode undefined.");
                return;
            }

            this._targets = [];
	
            // Get all transforms into animation states
            for(var clip in this._states)	
            {
                var channels = this._states[clip].getAnimationClip().getChannels();
        		for(var i=0;i<channels.length;i++)
        		{
                    if(this._rootNode.getName() === channels[i].getName())
                    {
                        this._targets.push(this._nodeRoot);
                    }
                    else
                    {
                        function isIntoTargets(targets, nodeName){
                           for(var t=0;t<targets.length;t++){
                                if(targets[t].getName()===nodeName)
                                    return true;
                           } 
                           return false;
                        }
                        if(!isIntoTargets(this._targets, channels[i].getName())){
                            var node = this._rootNode.findChildrenByName(channels[i].getName(),true);
                            for(var j=0;j<node.length;j++){
                                this._targets.push(node[j]);
                            }
                        }
                    }
		}
            }
        };
        
        LANA3D.AnimationHandler = function () {
            AnimationHandlerImpl.apply ( this, arguments );
        };

        LANA3D.AnimationHandler.prototype = AnimationHandlerImpl.prototype;

    })(LANA3D.Impl || (LANA3D.Impl = {}));
}) (LANA3D || (LANA3D = {}));

(function (LANA3D) {
    (function () {
        var _interface = LANA3D.AnimationManager;
        var _instance;
        var _handlers = {};

        var AnimInterpolationType = {   AIT_UNKNOWN :    -1,	///< No parse value
                                    AIT_NONE :       0,		///< No value given
                                    AIT_STEP :       1,
                                    AIT_LINEAR :     2,
                                    AIT_BEZIER :     3};
        var tangentKey = {
            'mTime': 0.0, 
            'mValue': 0.0
        };

        var interpolationKey = {
            'mType': AnimInterpolationType.AIT_LINEAR, 
            'mInTangentValue': tangentKey,
            'mOutTangentValue': tangentKey
        };

        var interpolationKeyVector = {
            'mInterpolationX': interpolationKey, 
            'mInterpolationY': interpolationKey,
            'mInterpolationZ': interpolationKey
        };
        var vectorKey = {
            'mTime': 0.0, 
            'mValue': new LANA3D.Vector3(0,0,0),
            'mInterpolation': interpolationKeyVector
        };
        
        var tangentQuat = {
            'mTime': 0.0, 
            'mValue': new LANA3D.Quaternion()
        };

        var interpolationQuat = {
            'mType': AnimInterpolationType.AIT_UNKNOWN, 
            'mInTangentValue': tangentQuat,
            'mOutTangentValue': tangentQuat
        };

        var quatKey = {
            'mTime': 0.0, 
            'mValue': new LANA3D.Quaternion(),
            'minterpolation': interpolationQuat
        };
                    
        function AnimationManagerImpl() {
            _interface.apply ( this, arguments );
        }
        AnimationManagerImpl.prototype = Object.create( LANA3D.AnimationManager.prototype);

        function getInstance() {
            if (_instance === undefined) {
                _instance = new AnimationManagerImpl();
            }
            return _instance;
        }

        AnimationManagerImpl.prototype.createDefaultHandlers = function (node, animationClips) {
            var ret = [];
            for(var i=0; i < animationClips.length; i++){
                var clip = animationClips[i];
                
                //Determine root node
                var rootNode;
                if (clip._loadedRootNodeName !== undefined) {
                    var nodes = node.findChildrenByName(clip._loadedRootNodeName, true);
                    if(nodes.length>0)
                        rootNode = nodes[0];
                    else
                        rootNode = node;
                } else {
                    throw new Error("Root node lookup not implemented.");
                }
                
                // Set handler
                var rootId = rootNode.getInternal().id;
                var handler;
                if(rootId in _handlers) {
                    handler = _handlers[rootId];
                } else {
                    handler = new LANA3D.AnimationHandler(rootNode);
                    _handlers[rootId] = handler;
                }
                
                if(ret.indexOf(handler) == -1){
                    ret.push(handler);
                }
                
                var lana3dClip = this.createAnimationClip(clip);

                //Set state
                var state = handler.addAnimationState(clip.getId(), lana3dClip );                     
            }
            return ret;
        };
        
        AnimationManagerImpl.prototype.destroyHandler = function ( handler ) {
            delete _handlers[handler.key];
        };

        AnimationManagerImpl.prototype.updateAnimations = function ( deltaTimeMS ) {
            var ret = false;
            for(var h in _handlers){
               if(_handlers[h].update(deltaTimeMS)) {
                    ret = true;
               }
            }
            return ret;
        };
        
        AnimationManagerImpl.prototype.createAnimationClip = function (anim){
            //create animationclip
            var lana3dClip = new LANA3D.AnimationClip();
            lana3dClip.setName(anim.getId());
            lana3dClip.setDuration(anim.getInternal().length);
            lana3dClip.setTicksPerSecond(anim.getInternal().fps);
            var channels = [];
            for(var j=0; j<anim.getInternal().hierarchy.length ;j++){
                var channel = new LANA3D.AnimationChannel();
                channel.setName(anim.getInternal().hierarchy[j].name);

                var traslationKeys = [];
                var scaleKeys = [];
                var rotationKeys = [];
                //number of keys
                for(var k=0; k < anim.getInternal().hierarchy[j].keys.length ;k++){
                    var key = anim.getInternal().hierarchy[j].keys[k];
                    if(key.pos){
                        var traslationKey = Object.create(vectorKey);
                        traslationKey.mTime = key.time * anim.getInternal().fps;
                        traslationKey.mValue = new LANA3D.Vector3(key.pos[0], key.pos[1], key.pos[2]);
                        
                        traslationKeys.push(traslationKey);
                    }
                    if(key.scl){
                        var scaleKey = Object.create(vectorKey);
                        scaleKey.mTime = key.time * anim.getInternal().fps;
                        scaleKey.mValue = new LANA3D.Vector3(key.scl[0], key.scl[1], key.scl[2]);
                        
                        scaleKeys.push(scaleKey);
                    }
                    if(key.rot){
                        var rotationKey = Object.create(quatKey);
                        rotationKey.mTime = key.time * anim.getInternal().fps;
                        rotationKey.mValue = new LANA3D.Quaternion(key.rot.getX(), key.rot.getY(), key.rot.getZ(), key.rot.getW());
                        
                        rotationKeys.push(rotationKey);
                    }                    
                }
                channel.setTraslationKeys(traslationKeys);
                channel.setScaleKeys(scaleKeys);
                channel.setRotationKeys(rotationKeys);

                channels.push(channel);
            }
            lana3dClip.setChannels(channels);
            
            return lana3dClip;
        };

        LANA3D.AnimationManager.getInstance = getInstance;
    })(LANA3D.Impl || (LANA3D.Impl = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Class to handle animation state
 * @constructor
 */
LANA3D.AnimationState = function () {
    
};

LANA3D.AnimationState.prototype = {   
    
    /**
     * Sets animation clip
     * @param {AnimationClip} clip
     */
    setAnimationClip: function ( animationClip) {},
    
    /**
     * Sets animation state
     * @param {bool} state
     */
    setEnabled: function ( enabled ) {},
    
    /**
     * Sets animation wrap mode
     * @param {WrapMode} mode
     */
    setWrapMode: function ( mode) {},
    
    /**
     * Sets animation weight
     * @param {float} weight
     */
    setWeight: function (weight) {},
    
    /**
     * Sets animation time value
     * @param {double} time
     */
    setTimeValue: function (time) {},
    
    /**
     * Sets animation speed value
     * @param {float} speed
     */
    setSpeed: function (speed) {},
    
    /**
     * Gets animation name
     * @returns {string} type
     */
    getName: function () {},
    
    /**
     * Gets animation clip
     * @returns {AnimationClip} clip
     */
    getAnimationClip: function () {},
    
    /**
     * Gets animation state
     * @returns {bool} state
     */
    getEnabled: function () {},
    
    /**
     * Gets animation wrap mode
     * @returns {WrapMode} mode
     */
    getWrapMode: function () {},
    
    /**
     * Gets animation time value
     * @returns {double} time
     */
    getTimeValue: function () {},
    
    /**
     * Gets animation weight
     * @returns {float} weight
     */
    getWeight: function () {},
    
    /**
     * Gets animation speed
     * @returns {float} speed
     */
    getSpeed: function () {}
};
(function (LANA3D) {
    (function () {
        function wrapModeEnum() {
            var values = {
                 Single: 0,
                 Loop: 1
            }

            return values;
        };
        function acEnum(){ 
            var values = {ACV_POSITIONX:0, 
                ACV_POSITIONY:1, 
                ACV_POSITIONZ:2,
                ACV_SCALEX:3,
                ACV_SCALEY:4,
                ACV_SCALEZ:5,
                ACV_FINAL:6};
            
            return values;
        }
        function animInterpolationType(){
            var values ={AIT_NONE:0,
                AIT_STEP:1,
                AIT_LINEAR:2,
                AIT_BEZIER:3,
                AIT_UNKNOWN:4
            };
            return values;
        }
        var _interface = LANA3D.AnimationState; 
        function AnimationStateImpl(name, clip, rootNode) {
            _interface.apply ( this, arguments );
            this._name = name;
            this._clip = clip;
            this._wrapMode = wrapModeEnum().Loop;
            this._t = 0.0;
            this._isEnabled = false;
            this._weight = 1.0;
            this._layer = 0.0;
            this._speed = 1.0;
            
            
            //to change
            var clipName = clip.getName();
            
            var refName = rootNode.id + "_" + clipName;
            clip.name = refName;
        }
        
        LANA3D.AnimationState = function () {
            AnimationStateImpl.apply ( this, arguments );
        };
        
        AnimationStateImpl.prototype = Object.create( LANA3D.AnimationState.prototype);

        AnimationStateImpl.prototype.setAnimationClip = function ( animationClip ) {
            this._clip = animationClip;
        };
        
        AnimationStateImpl.prototype.setEnabled = function ( enabled ) {
            this._isEnabled = enabled;
        };
        
        AnimationStateImpl.prototype.setWrapMode = function (wrapMode){
            this._wrapMode = wrapMode;
        };
        
        AnimationStateImpl.prototype.setWeight = function ( weight ) {
            this._weight = weight;
        };

        AnimationStateImpl.prototype.setLayer = function ( layer ) {
            this._layer = layer;
        };
        
        AnimationStateImpl.prototype.setTimeValue = function (time){
            this._t = time;
        };
        
        AnimationStateImpl.prototype.setSpeed = function(speed){
            this._speed = speed;
        };
        
        AnimationStateImpl.prototype.getName = function(){
            return this._name;
        };
        
        AnimationStateImpl.prototype.getAnimationClip = function(){
            return this._clip;
        };
        
        AnimationStateImpl.prototype.getEnabled = function ( ) {
            return this._isEnabled;
        };
        
        AnimationStateImpl.prototype.getWrapMode = function(){
            return this._wrapMode;
        };
        
        AnimationStateImpl.prototype.getTimeValue = function (){
            return this._t;
        };
        
        AnimationStateImpl.prototype.getWeight = function ( ) {
            return this._weight;
        };
        
        AnimationStateImpl.prototype.getSpeed = function (){
            return this._speed;
        };

        AnimationStateImpl.prototype.getLayer = function ( ) {
            return this._layer;
        };
        
        
        AnimationStateImpl.prototype.update = function(dtsec){
            
            var nodeTransforms = {};
            
            if(this._clip === undefined)
                return;
            
            if(this._isEnabled){
                //summ time since last update
                this._t += this._speed * dtsec;
            }
            
            var tAnim = this._clip.getDuration();
            var actualTick = this._t * this._clip.getTicksPerSecond();
            
            // Calculate a tranform for each node
            var i;
            for(i = 0; i < this._clip.getNumChannels() ; i++)
            {
        		var channeli = this._clip.getChannel(i);

        		// get traslation time keyframes
        		var traslationKeys = channeli.getTraslationKeys();

        		// Calculate current step
        		var traslation_step = 0;
        		for (traslation_step; traslation_step < traslationKeys.length - 1; traslation_step++)
        		{
        			if (actualTick < traslationKeys[traslation_step + 1].mTime)
        			{
        				// Found
        				break;
        			}
        		}

        		// get scale time keyframes
        		var scaleKeys = channeli.getScaleKeys();

        		// Calculate current step
        		var scale_step = 0;
        		for (scale_step; scale_step < scaleKeys.length - 1; scale_step++)
        		{
        			if (actualTick < scaleKeys[scale_step + 1].mTime)
        			{
        				// Found
        				break;
        			}
        		}

        		// get rotation time keyframes
        		var rotationKeys = channeli.getRotationKeys();

        		// Calculate current step
        		var rotation_step = 0;
        		for (rotation_step; rotation_step < rotationKeys.length - 1; rotation_step++)
        		{
        			if (actualTick < rotationKeys[rotation_step + 1].mTime)
        			{
        				// Found
        				break;
        			}
        		}

        		var transform = this.calculateTransformMatrix(channeli, new LANA3D.Vector3(rotation_step, traslation_step, scale_step));
        		nodeTransforms[channeli.getName()] = transform;
            }

            //check wrap mode and animation end
            if (this._t >= tAnim)
            {
                if (this._wrapMode === wrapModeEnum().Single)
                    this._isEnabled = false;

                //this._t -= tAnim;
                this._t = 0;

            }

            return nodeTransforms;
        };
        
        AnimationStateImpl.prototype.calculateTransformMatrix = function(channeli, steps){            
            var rotation = new LANA3D.Quaternion(0,0,0,1);
            var nextStep = steps.x;
            var numOfRotKeys = channeli.getNumberOfRotationKeys();
            if(numOfRotKeys>0){
                if (steps.x < numOfRotKeys - 1){
                    nextStep = steps.x + 1;
                }

                if (steps.x !== nextStep)
                {
                    var timei0 = channeli.getRotationKeyTime(steps.x) / this._clip.getTicksPerSecond();
                    var timei1 = channeli.getRotationKeyTime(nextStep) / this._clip.getTicksPerSecond();
                    var timeNorm = (this._t - timei0) / (timei1 - timei0);

                    var quadi0 = new LANA3D.Quaternion(channeli.getRotationKey(steps.x).mValue.x,
                            channeli.getRotationKey(steps.x).mValue.y,
                            channeli.getRotationKey(steps.x).mValue.z,
                            channeli.getRotationKey(steps.x).mValue.w);

                    var quadi1 = new LANA3D.Quaternion(channeli.getRotationKey(nextStep).mValue.x,
                            channeli.getRotationKey(nextStep).mValue.y,
                            channeli.getRotationKey(nextStep).mValue.z,
                            channeli.getRotationKey(nextStep).mValue.w);

                    // Linear interpolation
                    LANA3D.Quaternion.slerp( quadi0, quadi1, rotation, timeNorm );
                }
                else{
                    rotation = new LANA3D.Quaternion(channeli.getRotationKey(steps.x).mValue.x,
                            channeli.getRotationKey(steps.x).mValue.y,
                            channeli.getRotationKey(steps.x).mValue.z,
                            channeli.getRotationKey(steps.x).mValue.w);
                }
            }

            var translation = new LANA3D.Vector3(0,0,0);
            if(channeli.getNumberOfTraslationKeys()>0){
                translation.x = this.calculateVectorInterpolateValue(channeli, 
                    acEnum().ACV_POSITIONX, steps.y);
                translation.y = this.calculateVectorInterpolateValue(channeli, 
                    acEnum().ACV_POSITIONY, steps.y);
                translation.z = this.calculateVectorInterpolateValue(channeli, 
                    acEnum().ACV_POSITIONZ, steps.y);
            }
	
            var scale = new LANA3D.Vector3(1,1,1);
            if(channeli.getNumberOfScaleKeys()>0){
                scale.x = this.calculateVectorInterpolateValue(channeli, 
                    acEnum().ACV_SCALEX, steps.z);
                scale.y = this.calculateVectorInterpolateValue(channeli, 
                    acEnum().ACV_SCALEY, steps.z);
                scale.z = this.calculateVectorInterpolateValue(channeli, 
                    acEnum().ACV_SCALEZ, steps.z);
            }

            // Apply total transformation
            var transform = new LANA3D.Matrix4x4().makeTranslation(translation.x, translation.y, translation.z );
            var rotateMatrix = new LANA3D.Matrix4x4().makeRotationFromQuaternion(rotation);
            transform.scale(new LANA3D.Vector3(scale.x,scale.y,scale.z));
            transform.multiply(rotateMatrix);

            return transform;
        };

        AnimationStateImpl.prototype.calculateVectorInterpolateValue = function(channeli, variable, step){
            var keyTime, keyTimeNext;
            var keyValue, keyValueNext;
            var key, keyNext;
            var keySize;

            // Get data for interpolate
            switch(variable)
            {
		case acEnum().ACV_POSITIONX:
                    keyTime = channeli.getTraslationKeyTime(step);
                    keyValue = channeli.getTraslationKey(step).mValue.x;
                    key = channeli.getTraslationKey(step).mInterpolation.mInterpolationX;
                    keySize = channeli.getTraslationKeys().length;
                    if (keySize - 1 > step){
                        keyNext = channeli.getTraslationKey(step + 1).mInterpolation.mInterpolationX;
                        keyTimeNext = channeli.getTraslationKeyTime(step + 1);
                        keyValueNext = channeli.getTraslationKey(step + 1).mValue.x;
                    }
                    else{
                        keyNext = key;
                        keyTimeNext = keyTime;
                        keyValueNext = keyValue;
                    }

                    break;
		case acEnum().ACV_POSITIONY:
                    keyTime = channeli.getTraslationKeyTime(step);
                    keyValue = channeli.getTraslationKey(step).mValue.y;
                    key = channeli.getTraslationKey(step).mInterpolation.mInterpolationY;
                    keySize = channeli.getTraslationKeys().length;
                    if (keySize - 1 > step){
                        keyNext = channeli.getTraslationKey(step + 1).mInterpolation.mInterpolationY;
                        keyTimeNext = channeli.getTraslationKeyTime(step + 1);
                        keyValueNext = channeli.getTraslationKey(step + 1).mValue.y;
                    }
                    else{
                        keyNext = key;
                        keyTimeNext = keyTime;
                        keyValueNext = keyValue;
                    }
                    break;
		case acEnum().ACV_POSITIONZ:
                    keyTime = channeli.getTraslationKeyTime(step);
                    keyValue = channeli.getTraslationKey(step).mValue.z;
                    key = channeli.getTraslationKey(step).mInterpolation.mInterpolationZ;
                    keySize = channeli.getTraslationKeys().length;
                    if (keySize - 1 > step){
                        keyNext = channeli.getTraslationKey(step + 1).mInterpolation.mInterpolationZ;
                        keyTimeNext = channeli.getTraslationKeyTime(step + 1);
                        keyValueNext = channeli.getTraslationKey(step + 1).mValue.z;
                    }
                    else{
                        keyNext = key;
                        keyTimeNext = keyTime;
                        keyValueNext = keyValue;
                    }
                    break;
		case acEnum().ACV_SCALEX:
                    keyTime = channeli.getScaleKeyTime(step);
                    keyValue = channeli.getScaleKey(step).mValue.x;
                    key = channeli.getScaleKey(step).mInterpolation.mInterpolationX;
                    keySize = channeli.getScaleKeys().length;
                    if (keySize - 1 > step){
                        keyNext = channeli.getScaleKey(step + 1).mInterpolation.mInterpolationX;
                        keyTimeNext = channeli.getScaleKeyTime(step + 1);
                        keyValueNext = channeli.getScaleKey(step + 1).mValue.x;
                    }
                    else{
                        keyNext = key;
                        keyTimeNext = keyTime;
                        keyValueNext = keyValue;
                    }
                    break;
		case acEnum().ACV_SCALEY:
                    keyTime = channeli.getScaleKeyTime(step);
                    keyValue = channeli.getScaleKey(step).mValue.y;
                    key = channeli.getScaleKey(step).mInterpolation.mInterpolationY;
                    keySize = channeli.getScaleKeys().length;
                    if (keySize - 1 > step){
                        keyNext = channeli.getScaleKey(step + 1).mInterpolation.mInterpolationY;
                        keyTimeNext = channeli.getScaleKeyTime(step + 1);
                        keyValueNext = channeli.getScaleKey(step + 1).mValue.y;
                    }
                    else{
                        keyNext = key;
                        keyTimeNext = keyTime;
                        keyValueNext = keyValue;
                    }
                    break;
		case acEnum().ACV_SCALEZ:
                    keyTime = channeli.getScaleKeyTime(step);
                    keyValue = channeli.getScaleKey(step).mValue.z;
                    key = channeli.getScaleKey(step).mInterpolation.mInterpolationZ;
                    keySize = channeli.getScaleKeys().length;
                    if (keySize - 1 > step){
                        keyNext = channeli.getScaleKey(step + 1).mInterpolation.mInterpolationZ;
                        keyTimeNext = channeli.getScaleKeyTime(step + 1);
                        keyValueNext = channeli.getScaleKey(step + 1).mValue.z;
                    }
                    else{
                        keyNext = key;
                        keyTimeNext = keyTime;
                        keyValueNext = keyValue;
                    }
                    break;
		default:
                    break;
            }
            
            return this.computeVectorInterpolationData(keySize, step, key,keyNext,
                                keyTime, keyValue, keyTimeNext, keyValueNext);
        };
        
        AnimationStateImpl.prototype.computeVectorInterpolationData = function(
                interpolationKeyNum, step,
		stepInterpolation,
		stepNextInterpolation,
		stepInterpolationKeyTime,
		stepInterpolationKeyValue,
		nextInterpolationKeyTime,
		nextInterpolationKeyValue){
            
            var interpolation = stepInterpolation.mType;
            var stepTime = stepInterpolationKeyTime / this._clip.getTicksPerSecond();
            var stepValue = stepInterpolationKeyValue;
            var nextStepTime, nextStepValue;
            var t = 0.0;
            
            // Use data with interpolation
            switch (interpolation)
            {
                case animInterpolationType().AIT_NONE:
                    break;
                case animInterpolationType().AIT_STEP:
                    return stepValue;
                case animInterpolationType().AIT_LINEAR:
                    nextStepTime = nextInterpolationKeyTime / this._clip.getTicksPerSecond();
                    nextStepValue = nextInterpolationKeyValue;
                    if (nextStepTime !== stepTime){
			t = (this.getTimeValue() - stepTime) / (nextStepTime - stepTime);
			return this.linearPointFromCheckpoints(t, stepValue, nextStepValue);
                    }
                    else{
			return stepValue;
                    }
                    break;
                case animInterpolationType().AIT_BEZIER:
                    nextStepTime = stepInterpolation.mOutTangentValue.mTime / this._clip.getTicksPerSecond();
                    nextStepValue = stepInterpolation.mOutTangentValue.mValue;
                    var nextStepInTangentTime = stepNextInterpolation.mInTangentValue.mTime / this._clip.getTicksPerSecond();
                    var nextStepInTangentValue = stepNextInterpolation.mInTangentValue.mValue;
                    var nextStepOutTangentTime = nextInterpolationKeyTime / this._clip.getTicksPerSecond();
                    var nextStepOutTangentValue = nextInterpolationKeyValue;
                    if (nextStepOutTangentTime !== stepTime){
			t = (this.getTimeValue() - stepTime) / (nextStepOutTangentTime - stepTime);
                    }
                    return this.bezierPointFromCheckpoints(t, stepValue, 
                                        nextStepValue, nextStepInTangentValue, 
                                        nextStepOutTangentValue);
                case animInterpolationType().AIT_UNKNOWN:
                    break;
                default:
                    console.log("Unknown interpolation method.");
                    return -1; // -1?
            }

            return 0.0;
        };
        
        AnimationStateImpl.prototype.linearPointFromCheckpoints = function(t, p0, p1){
            return p0 + (p1 - p0)*t;
        };

        AnimationStateImpl.prototype.bezierPointFromCheckpoints = function (t, p0, p1, p2, p3){
            var C1 = ( p3 - (3.0 * p2) + (3.0 * p1) - p0 );
            var C2 = ( (3.0 * p2) - (6.0 *p1) + (3.0 * p0) );
            var C3 = ( (3.0 * p1) - (3.0 * p0) );
            var C4 = ( p0 );

            return ( C1*t*t*t + C2*t*t + C3*t + C4  );
        };

        AnimationStateImpl.prototype.bezierPointFromTangent = function( t, p0, t0, t1, p3){
            var p1 = t0/3 + p0;
            var p2 = p3 - t1/3;

            return bezierPointFromCheckpoints(t, p0, p1, p2, p3);
        };

        AnimationStateImpl.prototype.bezierTangent = function (t, p0, p1, p2, p3)
        {
            var C1 = ( p3 - (3.0 * p2) + (3.0 * p1) - p0 );
            var C2 = ( (3.0 * p2) - (6.0 * p1) + (3.0 * p0) );
            var C3 = ( (3.0 * p1) - (3.0 * p0) );
            var C4 = ( p0 );

            return ( ( 3.0 * C1 * t* t ) + ( 2.0 * C2 * t ) + C3 );
        };

        LANA3D.AnimationState.prototype = AnimationStateImpl.prototype;

    })(LANA3D.Impl || (LANA3D.Impl = {}));
}) (LANA3D || (LANA3D = {}));

(function (LANA3D) {
    (function () {
        var _interface = LANA3D.AnimationChannel; 
        
        AnimationChannelImpl.prototype = Object.create( LANA3D.AnimationChannel.prototype);
        
        function AnimationChannelImpl() {
            _interface.apply ( this, arguments );
        }
    
        AnimationChannelImpl.prototype.getName = function () {
            return this._nodeName;
        };

        AnimationChannelImpl.prototype.setName = function ( name ) {
            this._nodeName = name;
        };
   
        AnimationChannelImpl.prototype.getTraslationKeys = function () {
            return this._traslationKeys;
        };

        AnimationChannelImpl.prototype.setTraslationKeys = function ( traslationKeys ) {
            this._traslationKeys = traslationKeys;
        };
   
        AnimationChannelImpl.prototype.getScaleKeys = function () {
            return this._scaleKeys;
        };

        AnimationChannelImpl.prototype.setScaleKeys = function ( scaleKeys ) {
            this._scaleKeys = scaleKeys;
        };
   
        AnimationChannelImpl.prototype.getRotationKeys = function () {
            return this._rotationKeys;
        };

        AnimationChannelImpl.prototype.setRotationKeys = function ( rotationKeys ) {
            this._rotationKeys = rotationKeys;
        };
   
        AnimationChannelImpl.prototype.getTraslationKey = function (keyId) {
            return this._traslationKeys[keyId];
        };
   
        AnimationChannelImpl.prototype.getScaleKey = function (keyId) {
            return this._scaleKeys[keyId];
        };
   
        AnimationChannelImpl.prototype.getRotationKey = function (keyId) {
            return this._rotationKeys[keyId];
        };
   
        AnimationChannelImpl.prototype.getNumberOfTraslationKeys = function () {
            return this._traslationKeys.length;
        };
   
        AnimationChannelImpl.prototype.getNumberOfScaleKeys = function () {
            return this._scaleKeys.length;
        };
   
        AnimationChannelImpl.prototype.getNumberOfRotationKeys = function () {
            return this._rotationKeys.length;
        };
    
        AnimationChannelImpl.prototype.getTraslationKeyTime = function (keyId) {
            return this._traslationKeys[keyId].mTime;
        };
   
        AnimationChannelImpl.prototype.getScaleKeyTime = function (keyId) {
            return this._scaleKeys[keyId].mTime;
        };
   
        AnimationChannelImpl.prototype.getRotationKeyTime = function (keyId) {
            return this._rotationKeys[keyId].mTime;
        };
        
        LANA3D.AnimationChannel.prototype = AnimationChannelImpl.prototype;

    })(LANA3D.Impl || (LANA3D.Impl = {}));
}) (LANA3D || (LANA3D = {}));

/**
 * Class to manage kinematic chain animation
 * @constructor
 */
LANA3D.AnimationKineChain = function () {
    
};

LANA3D.AnimationKineChain.prototype = {   
    
    /**
     * Sets chain root
     * @param {root} chain root node
     */
    setRoot: function ( root ) {},
    
    /**
     * Sets animation state
     * @param {bool} state
     */
    setEnabled: function ( enabled ) {},
    
    /**
     * Gets animation state
     * @returns {bool} state
     */
    getEnabled: function () {},
    
    /**
     * Compute chain animation
     * @param {Vector3} chain end position
     * @returns {bool} True if a solution exists, False if the position isn't in reach
     */
    ComputeCCDLink: function ( endPos ) {}
};
(function (LANA3D) {
    (function () {
        
        var _interface = LANA3D.AnimationKineChain; 
        function AnimationKineChainImpl( root ) {
            _interface.apply ( this, arguments );
            this._root = root;  
            this._isEnabled = false;
           
           this._link = [];
           //get links from root structure
           var link = root;
           while(link){
                this._link.push(link);
                var goodChildren = false;
                for(var i = 0; i< link.getChildren().length; i++){
                    if(link.getChildren()[i].type==="mesh"){
                        link = link.getChildren()[i];
                        goodChildren = true;
                    }
                }

                if(!goodChildren){
                    link = undefined;
                }
           }
            
        }
        
        LANA3D.AnimationKineChain = function () {
            AnimationKineChainImpl.apply ( this, arguments );
        };
        
        AnimationKineChainImpl.prototype = Object.create( LANA3D.AnimationKineChain.prototype);
        
        AnimationKineChainImpl.prototype.setEnabled = function ( enabled ) {
            this._isEnabled = enabled;
        };   
        
        AnimationKineChainImpl.prototype.getEnabled = function ( ) {
            return this._isEnabled;
        };
        
        AnimationKineChainImpl.prototype.ComputeCCDLink = function(endPos, DOF_Restrict){
            
            /// Local Variables ///////////////////////////////////////////////////////////
            var link,tries;
            var IK_POS_THRESH = 20.0; // THRESHOLD FOR SUCCESS
            var MAX_IK_TRIES = 60;
            var damp_width = 0.1; //degrees
            var damping = true;
        ///////////////////////////////////////////////////////////////////////////////
            // START AT THE LAST LINK IN THE CHAIN
            link = this._link.length - 2;
            tries = 0;                      // LOOP COUNTER SO I KNOW WHEN TO QUIT
            do
            {
                // THE COORDS OF THE X,Y,Z POSITION OF THE ROOT OF THIS BONE IS IN THE MATRIX
                // TRANSLATION PART WHICH IS IN THE 12,13,14 POSITION OF THE MATRIX
                var rootPos = this._link[link].getInternal().matrixWorld.getPosition();

                // POSITION OF THE END EFFECTOR
                var curEnd = this._link[this._link.length - 1].getInternal().matrixWorld.getPosition();

                // SEE IF I AM ALREADY CLOSE ENOUGH

                if (this.VectorSquaredDistance(curEnd, endPos) > IK_POS_THRESH)
                {
                    // CREATE THE VECTOR TO THE CURRENT EFFECTOR POS
                    var curVector = {x:curEnd.x - rootPos.x, y: curEnd.y - rootPos.y, z: curEnd.z - rootPos.z};
                    // CREATE THE DESIRED EFFECTOR POSITION VECTOR
                    var targetVector = { x: endPos.x - rootPos.x, y: endPos.y - rootPos.y, z: endPos.z - rootPos.z};

                    // NORMALIZE THE VECTORS (EXPENSIVE, REQUIRES A SQRT)
      /*              this.NormalizeVector(curVector);
                    this.NormalizeVector(targetVector);

                    // THE DOT PRODUCT GIVES ME THE COSINE OF THE DESIRED ANGLE
                    var normCosAngle = this.DotProduct(targetVector, curVector);

                    //if the dot product returns  1.0, i don't need to rotate as it is 0 degrees
                //    if(normCosAngle < 0.9999)
                    {

                        // USE THE CROSS PRODUCT TO CHECK WHICH WAY TO ROTATE
                        var crossResult = this.CrossProduct(curVector, targetVector);
                        this.NormalizeVector(crossResult);

                        // Force the dot product of the two input vectors to 
                        // fall within the domain for inverse cosine, which 
                        // is -1 <= x <= 1. This will prevent runtime 
                        // "domain error" math exceptions.
                        normCosAngle = ( normCosAngle < -1.0 ? -1.0 : ( normCosAngle > 1.0 ? 1.0 : normCosAngle ) );

                        var turnAngle = Math.acos(normCosAngle / (this.VectorLength(targetVector) + this.VectorLength(curVector)));  // GET THE ANGLE
                        var turnDeg = ((turnAngle * 180.0) / 3.14159265358979323846)      // COVERT TO DEGREES
                        
                        // DAMPING
                        if (damping && turnDeg > damp_width) 
                           turnAngle = damp_width * 3.14159265358979323846 / 180.0;
                        
                        var rotation = this.AxisAngleToQuat(crossResult, turnAngle);
          
                        var rotateMatrix = new LANA3D.Matrix4x4().makeRotationFromQuaternion(rotation);
                        var localMat = this._link[link].getLocalTransform().getMatrix();
                        var resultMat = localMat.multiply(rotateMatrix);            
                        
                        // HANDLE THE DOF RESTRICTIONS IF I WANT THEM
                        if (DOF_Restrict)
                            this.CheckDOFRestrictions(this._link[link], resultMat);

                        //apply new trasnformation
                        this._link[link].setLocalTransform(resultMat);
                    }*/
                    if( this.VectorLength(targetVector) > 0.001 && this.VectorLength(curVector) > 0.001 )
                    {
                         // NORMALIZE THE VECTORS (EXPENSIVE, REQUIRES A SQRT)
                        this.NormalizeVector(curVector);
                        this.NormalizeVector(targetVector);
                            
                        // USE THE CROSS PRODUCT TO CHECK WHICH WAY TO ROTATE
                        var crossResult = this.CrossProduct(curVector, targetVector);
                        if( this.VectorLength(crossResult) > 0.001 )
                        {
                            this.NormalizeVector(crossResult);
                            // THE DOT PRODUCT GIVES ME THE COSINE OF THE DESIRED ANGLE
                            var normCosAngle = this.DotProduct(targetVector, curVector);
                            normCosAngle = ( normCosAngle < -1.0 ? -1.0 : ( normCosAngle > 1.0 ? 1.0 : normCosAngle ) );
                            var turnAngle = Math.acos(normCosAngle);
                            var turnDeg = ((turnAngle * 180.0) / 3.14159265358979323846)      // COVERT TO DEGREES

                            // DAMPING
                            if (damping && turnDeg > damp_width) 
                                turnAngle = damp_width * 3.14159265358979323846 / 180.0;

                            var rotation = this.AxisAngleToQuat(crossResult, turnAngle);
          
                            var rotateMatrix = new LANA3D.Matrix4x4().makeRotationFromQuaternion(rotation);
                            var localMat = this._link[link].getLocalTransform().getMatrix();
                            var resultMat = rotateMatrix.multiply(localMat);            
                            
                            // HANDLE THE DOF RESTRICTIONS IF I WANT THEM
                            if (DOF_Restrict)
                                this.CheckDOFRestrictions(this._link[link], resultMat);

                            //apply new trasnformation
                            this._link[link].setLocalTransform(resultMat);
                        }
                    }

                    
                    if (--link < 0) link = this._link.length - 2;    // START OF THE CHAIN, RESTART
                }else{
                    return true;
                }
            // QUIT IF I AM CLOSE ENOUGH OR BEEN RUNNING LONG ENOUGH
            } while (tries++ < MAX_IK_TRIES);
            
            return false;
        };

        AnimationKineChainImpl.prototype.MultQuaternions = function(q1,q2) {
            var quat = new LANA3D.Quaternion;
            quat.x =  q1.x * q2.w + q1.y * q2.z - q1.z * q2.y + q1.w * q2.x;
            quat.y = -q1.x * q2.z + q1.y * q2.w + q1.z * q2.x + q1.w * q2.y;
            quat.z =  q1.x * q2.y - q1.y * q2.x + q1.z * q2.w + q1.w * q2.z;
            quat.w = -q1.x * q2.x - q1.y * q2.y - q1.z * q2.z + q1.w * q2.w;
            return quat;
        }

        AnimationKineChainImpl.prototype.AxisAngleToQuat = function (axis, angle)
        {
            var quat = new LANA3D.Quaternion();

            var epsilon = 0.0000001;

            var length = Math.sqrt( axis.x*axis.x + axis.y*axis.y + axis.z*axis.z );
            if (length < epsilon)
            {
                // ~zero length axis, so reset rotation to zero.
                return quat;
            }

            var inversenorm  = 1.0/length;
            var coshalfangle = Math.cos( 0.5*angle );
            var sinhalfangle = Math.sin( 0.5*angle );

            quat.x = axis.x * sinhalfangle * inversenorm;
            quat.y = axis.y * sinhalfangle * inversenorm;
            quat.z = axis.z * sinhalfangle * inversenorm;
            quat.w = coshalfangle;

            return quat;
        }

        AnimationKineChainImpl.prototype.NormalizeQuaternion = function(quat){

            // FIRST STEP, FIND THE MAGNITUDE
            var magnitude = (quat.x * quat.x) + 
                        (quat.y * quat.y) + 
                        (quat.z * quat.z) + 
                        (quat.w * quat.w);

            // DIVIDE BY THE MAGNITUDE TO NORMALIZE
            quat.x = quat.x / magnitude;
            quat.y = quat.y / magnitude;
            quat.z = quat.z / magnitude;
            quat.w = quat.w / magnitude;
        };
        
        AnimationKineChainImpl.prototype.EulerToQuaternion = function(rot){
        /// Local Variables ///////////////////////////////////////////////////////////
            var rx,ry,rz,tx,ty,tz,cx,cy,cz,sx,sy,sz,cc,cs,sc,ss;
        ///////////////////////////////////////////////////////////////////////////////
            // FIRST STEP, CONVERT ANGLES TO RADIANS
            rx =  (rot.x * 3.14159265358979323846) / (360 / 2);
            ry =  (rot.y * 3.14159265358979323846) / (360 / 2);
            rz =  (rot.z * 3.14159265358979323846) / (360 / 2);
            // GET THE HALF ANGLES
            tx = rx * 0.5;
            ty = ry * 0.5;
            tz = rz * 0.5;
            cx = Math.cos(tx);
            cy = Math.cos(ty);
            cz = Math.cos(tz);
            sx = Math.sin(tx);
            sy = Math.sin(ty);
            sz = Math.sin(tz);

            cc = cx * cz;
            cs = cx * sz;
            sc = sx * cz;
            ss = sx * sz;

            var quat = {x:0,y:0,z:0,w:0};

            quat.x = (cy * sc) - (sy * cs);
            quat.y = (cy * ss) + (sy * cc);
            quat.z = (cy * cs) - (sy * sc);
            quat.w = (cy * cc) + (sy * ss);

            // INSURE THE QUATERNION IS NORMALIZED
            // PROBABLY NOT NECESSARY IN MOST CASES
            this.NormalizeQuaternion(quat);

            return quat;
        };

        AnimationKineChainImpl.prototype.CheckDOFRestrictions = function(link, resultMat){            

            // FIRST STEP IS TO CONVERT LINK QUATERNION BACK TO EULER ANGLES
            var euler = resultMat.rotation;

            // CHECK THE DOF SETTINGS
            if (euler.x > link.max_rx) 
                euler.x = link.max_rx;
            if (euler.x < link.min_rx) 
                euler.x = link.min_rx;
            if (euler.y > link.max_ry) 
                euler.y = link.max_ry;
            if (euler.y < link.min_ry) 
                euler.y = link.min_ry;
            if (euler.z > link.max_rz) 
                euler.z = link.max_rz;
            if (euler.z < link.min_rz) 
                euler.z = link.min_rz;

            // BACK TO QUATERNION
           // var quat = EulerToQuaternion(euler);
            //link.quaternion.x = quat.x; link.quaternion.y = quat.y; link.quaternion.z = quat.z; link.quaternion.w = quat.w;
            resultMat.rotation = euler;
        };

        AnimationKineChainImpl.prototype.VectorSquaredLength = function(v) {
            return((v.x * v.x) + (v.y * v.y) + (v.z * v.z));
        };

        AnimationKineChainImpl.prototype.VectorLength = function (v){
            return(Math.sqrt(this.VectorSquaredLength(v)));
        };

        AnimationKineChainImpl.prototype.NormalizeVector = function (v){
            var len = this.VectorLength(v);
            if (len != 0.0) 
            { 
                v.x /= len;  
                v.y /= len; 
                v.z /= len; 
            }
        };

        AnimationKineChainImpl.prototype.VectorSquaredDistance = function (v1, v2) {
            return Math.sqrt( ((v1.x - v2.x) * (v1.x - v2.x)) + 
                    ((v1.y - v2.y) * (v1.y - v2.y)) +   
                    ((v1.z - v2.z) * (v1.z - v2.z)) );  
        };

        AnimationKineChainImpl.prototype.DotProduct = function (v1, v2) {
            return ((v1.x * v2.x) + (v1.y * v2.y) + (v1.z + v2.z));
        };

        AnimationKineChainImpl.prototype.CrossProduct = function (v1, v2){
            var result = {x:0, y:0, z:0};

            result.x = (v1.y * v2.z) - (v1.z * v2.y);
            result.y = (v1.z * v2.x) - (v1.x * v2.z);
            result.z = (v1.x * v2.y) - (v1.y * v2.x);

            return result;
        };

        AnimationKineChainImpl.prototype.QuatToEuler = function(quat){
            /// Local Variables ///////////////////////////////////////////////////////////
            var matrix = [3][3];
            var cx,sx,x;
            var cy,sy,y,yr;
            var cz,sz,z;
            var euler = {x:0,y:0,z:0};

        ///////////////////////////////////////////////////////////////////////////////
            // CONVERT QUATERNION TO MATRIX - I DON'T REALLY NEED ALL OF IT
            matrix[0][0] = 1.0 - (2.0 * quat.y * quat.y) - (2.0 * quat.z * quat.z);
        //  matrix[0][1] = (2.0 * quat->x * quat->y) - (2.0 * quat->w * quat->z);
        //  matrix[0][2] = (2.0 * quat->x * quat->z) + (2.0 * quat->w * quat->y);
            matrix[1][0] = (2.0 * quat.x * quat.y) + (2.0 * quat.w * quat.z);
        //  matrix[1][1] = 1.0 - (2.0 * quat->x * quat->x) - (2.0 * quat->z * quat->z);
        //  matrix[1][2] = (2.0 * quat->y * quat->z) - (2.0 * quat->w * quat->x);
            matrix[2][0] = (2.0 * quat.x * quat.z) - (2.0 * quat.w * quat.y);
            matrix[2][1] = (2.0 * quat.y * quat.z) + (2.0 * quat.w * quat.x);
            matrix[2][2] = 1.0 - (2.0 * quat.x * quat.x) - (2.0 * quat.y * quat.y);

            sy = -matrix[2][0];
            cy = Math.sqrt(1 - (sy * sy));
            yr = Math.atan2(sy,cy);
            euler.y = (yr * 180.0) / 3.14159265358979323846;

            // AVOID DIVIDE BY ZERO ERROR ONLY WHERE Y= +-90 or +-270 
            // NOT CHECKING cy BECAUSE OF PRECISION ERRORS
            if (sy != 1.0 && sy != -1.0)  
            {
                cx = matrix[2][2] / cy;
                sx = matrix[2][1] / cy;
                euler.x = (Math.atan2(sx,cx) * 180.0) / 3.14159265358979323846;    // RAD TO DEG

                cz = matrix[0][0] / cy;
                sz = matrix[1][0] / cy;
                euler.z = (Math.atan2(sz,cz) * 180.0) / 3.14159265358979323846;    // RAD TO DEG
            }
            else
            {
                // SINCE Cos(Y) IS 0, I AM SCREWED.  ADOPT THE STANDARD Z = 0
                // I THINK THERE IS A WAY TO FIX THIS BUT I AM NOT SURE.  EULERS SUCK
                // NEED SOME MORE OF THE MATRIX TERMS NOW
                matrix[1][1] = 1.0 - (2.0 * quat.x * quat.x) - (2.0 * quat.z * quat.z);
                matrix[1][2] = (2.0 * quat.y * quat.z) - (2.0 * quat.w * quat.x);
                cx = matrix[1][1];
                sx = -matrix[1][2];
                euler.x = (Math.atan2(sx,cx) * 180.0) / 3.14159265358979323846;    // RAD TO DEG

                cz = 1.0;
                sz = 0.0;
                euler.z = (Math.atan2(sz,cz) * 180.0) / 3.14159265358979323846;    // RAD TO DEG
            }

            return euler;
        };


        LANA3D.AnimationKineChain.prototype = AnimationKineChainImpl.prototype;

    })(LANA3D.Impl || (LANA3D.Impl = {}));
}) (LANA3D || (LANA3D = {}));

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


;
